<template>
  <div class="map-page">
    <v-app-bar v-if="showTabs" app fixed :class="sidebar ? 'header-left' : ''">
      <v-tabs v-model="tab">
        <v-tab
          @click="
            sidebar = false;
            citiesFilter = '';
            filterType = 'city';
          "
          class="tab-title"
          >نقشه تعاملی</v-tab
        >
        <v-tab
          @click="
            sidebar = false;
            titlesFilter = '';
            filterType = 'title';
          "
          class="tab-title"
          :disabled="!mapLoaded"
          >موضوعات</v-tab
        >
        <v-tab
          @click="
            sidebar = false;
            titlesFilter = '';
            filterType = 'mehvar';
          "
          :disabled="!mapLoaded"
          class="tab-title"
          >محور‌ها</v-tab
        >
        <!-- <v-tab
          @click="
            sidebar = false;
            titlesFilter = '';
            filterType = 'accelerators';
          "
          :disabled="!mapLoaded"
          class="tab-title"
          >شتاب‌دهنده‌ها</v-tab
        > -->
        <v-tab
          @click="
            sidebar = false;
            titlesFilter = '';
            filterType = 'companies';
          "
          :disabled="!mapLoaded"
          class="tab-title"
          >شرکت‌های دانش بنیان</v-tab
        >
        <v-tab
          @click="
            sidebar = false;
            titlesFilter = '';
            filterType = 'organizations';
          "
          :disabled="!mapLoaded"
          class="tab-title"
          >انجمن‌های دانشگاهی</v-tab
        >
      </v-tabs>
      <v-spacer></v-spacer>
      <v-btn
        @click="goTo()"
        text
        class="me-5 bc-primary white--text"
        elevation="0"
        v-if="!sidebar"
      >
        <v-icon class="pe-2">login</v-icon>
        {{ role ? "بازگشت به داشبورد" : "ورود به سامانه" }}
      </v-btn>
    </v-app-bar>
    <transition name="sidebar">
      <v-navigation-drawer
        app
        v-model="sidebar"
        class="drawer"
        :permanent="sidebar"
      >
        <v-row class="mt-1 ms-1 me-1">
          <v-col cols="9" v-if="filterType == 'city'">
            <div v-if="fromProfiles" class="my-2 pe-1 c-dark fs-large">
              استان {{ selectedState }}
              <br />
              <div
                v-if="stateInfo.motto"
                class="grey--text text--darken-1 pt-1"
              >
                {{ stateInfo.motto }}
              </div>
            </div>
            <div v-else>
              <div v-if="selectedCity.key" class="my-2 pe-1 c-dark">
                <span class="fs-large"
                  >استان {{ selectedCity.mapData.name }}</span
                >

                <br />
                <div
                  v-if="stateInfo.motto"
                  class="grey--text text--darken-1 pt-1"
                >
                  {{ stateInfo.motto }}
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="9" v-if="filterType == 'title'">
            <div v-if="selectedTitle.length" class="m-2">
              {{ selectedTitle[0].name }}
            </div></v-col
          >
          <v-col cols="9" v-else-if="filterType == 'mehvar'">
            <div v-if="selectedTitle.length" class="m-2">
              {{ selectedTitle }}
            </div></v-col
          >
          <v-col cols="3" class="text-left">
            <span class="pointer" @click="closeSidebar()"
              ><v-icon class="pt-2">$ArrowLeft</v-icon></span
            >
          </v-col>

          <v-row v-if="busy">
            <v-col class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular
            ></v-col>
          </v-row>
          <v-row v-if="!busy" class="mx-1">
            <!-- state description -->
            <v-col
              cols="12"
              class="w-100 pb-6"
              v-if="
                filterType == 'city' &&
                selectedCity.mapData &&
                stateInfo.description &&
                !fromProfiles
              "
            >
              <div class="description-box">
                <div
                  class="box-title grey--text text--darken-1 font-weight-bold"
                >
                  شرح فعالیت‌ها
                </div>
                <div
                  v-html="stateInfo.description ? stateInfo.description : ''"
                ></div>
              </div>
              <hr class="mb-0" />
            </v-col>
            <v-col
              cols="12"
              class="w-100 pb-6"
              v-else-if="fromProfiles && stateInfo.description"
            >
              <div class="description-box">
                <div
                  class="box-title grey--text text--darken-1 font-weight-bold"
                >
                  شرح فعالیت‌ها
                </div>
                <div
                  v-html="stateInfo.description ? stateInfo.description : ''"
                ></div>
              </div>
              <hr class="mb-0" />
            </v-col>
            <v-col>
              <div
                v-if="
                  !stateInfo.distinguishedUniversitiesCount &&
                  !stateInfo.universitiesCount &&
                  !stateInfo.researchersCount &&
                  !stateInfo.acceleratorsCount &&
                  !stateInfo.companiesCount &&
                  !stateInfo.organizationsCount &&
                  !stateInfo.mehvarsCount
                "
                class="c-grey text-center"
              >
                <v-icon color="red" class="mb-2" large>mdi-alert</v-icon>
                <br />
                هنوز کاربری به این استان برای ثبت در سامانه تقسیم کار ملی
                درخواست نداده است.
              </div>
              <div v-if="stateInfo.distinguishedUniversitiesCount != 0">
                <span class="pe-3 fs-medium c-dark"
                  ><v-icon class="me-1">mdi-star</v-icon>دانشگاه‌های برتر ({{
                    stateInfo.distinguishedUniversitiesCount
                  }})
                </span>
                <v-row class="pt-3 px-2">
                  <v-col
                    cols="4"
                    v-for="(
                      item, index
                    ) in stateInfo.distinguishedUniversities.slice(0, 3)"
                    :key="index"
                    class="text-center"
                  >
                    <router-link :to="'universityProfile/' + item.id">
                      <img
                        class="item-img mx-auto"
                        :src="item.avatar ? item.avatar : '/uniDisLogo.png'"
                      />
                      <div
                        class="text-center fs-xsmall c-dark font-weight-bold"
                      >
                        {{ item.name }}
                      </div>
                    </router-link>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center pt-3">
                    <v-btn
                      @click="openModal('distinguishedUni')"
                      v-if="stateInfo.distinguishedUniversitiesCount > 3"
                      text
                      class="seeMore text-primary"
                    >
                      همه دانشگاه‌ها
                      <v-icon class="px-2" color="primary">$ArrowLeft</v-icon>
                    </v-btn></v-col
                  >
                </v-row>
                <hr />
              </div>
              <div v-if="stateInfo.universitiesCount != 0">
                <span class="pe-3 fs-medium c-dark"
                  >دانشگاه‌ها ({{ stateInfo.universitiesCount }})</span
                >
                <v-row class="pt-3 px-2">
                  <v-col
                    cols="4"
                    v-for="(item, index) in stateInfo.universities.slice(0, 3)"
                    :key="index"
                    class="text-center"
                  >
                    <router-link :to="'universityProfile/' + item.id">
                      <img
                        class="item-img mx-auto"
                        :src="item.avatar ? item.avatar : '/uniLogo.png'"
                      />
                      <div
                        class="text-center fs-xsmall c-dark font-weight-bold"
                      >
                        {{ item.name }}
                      </div>
                    </router-link>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center pt-3">
                    <v-btn
                      @click="openModal('uni')"
                      v-if="stateInfo.universitiesCount > 3"
                      text
                      class="seeMore text-primary"
                    >
                      همه دانشگاه‌ها
                      <v-icon class="px-2" color="primary">$ArrowLeft</v-icon>
                    </v-btn></v-col
                  >
                </v-row>
                <hr />
              </div>

              <div
                v-if="stateInfo.researchers && stateInfo.researchersCount != 0"
              >
                <span class="pe-3 fs-medium c-dark"
                  ><v-icon class="me-1">mdi-star</v-icon>پژوهشگران برتر ({{
                    stateInfo.researchersCount
                  }})
                </span>
                <v-row class="pt-3 px-2">
                  <v-col
                    cols="4"
                    v-for="(item, index) in stateInfo.researchers.slice(0, 3)"
                    :key="index"
                    class="text-center"
                  >
                    <router-link :to="'researcherProfile/' + item.id">
                      <img
                        class="item-img mx-auto"
                        :src="item.avatar ? item.avatar : '/researcherLogo.png'"
                      />
                      <div
                        class="text-center fs-xsmall c-dark font-weight-bold"
                      >
                        {{ item.name }}
                      </div>
                    </router-link>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center pt-3">
                    <v-btn
                      @click="openModal('researcher')"
                      v-if="
                        stateInfo.researchers && stateInfo.researchersCount > 3
                      "
                      text
                      class="seeMore text-primary"
                    >
                      همه پژوهشگران برتر
                      <v-icon class="px-2" color="primary">$ArrowLeft</v-icon>
                    </v-btn></v-col
                  >
                </v-row>
                <hr />
              </div>
              <!-- <div v-if="stateInfo.acceleratorsCount != 0">
                <span class="pe-3 fs-medium c-dark"
                  >شتاب‌دهنده‌ها ({{ stateInfo.acceleratorsCount }})</span
                >
                <v-row class="pt-3 px-2">
                  <v-col
                    cols="4"
                    v-for="(item, index) in stateInfo.accelerators.slice(0, 3)"
                    :key="index"
                    class="text-center"
                  >
                    <router-link :to="'acceleratorProfile/' + item.id">
                      <img
                        class="item-img mx-auto"
                        :src="item.avatar ? item.avatar : '/companyLogo.png'"
                      />
                      <div
                        class="text-center fs-xsmall c-dark font-weight-bold"
                      >
                        {{ item.name }}
                      </div>
                    </router-link>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center pt-3">
                    <v-btn
                      @click="openModal('accelerator')"
                      v-if="stateInfo.acceleratorsCount > 3"
                      text
                      class="seeMore text-primary"
                    >
                      همه شتاب‌دهنده‌ها<v-icon class="px-2" color="primary"
                        >$ArrowLeft</v-icon
                      >
                    </v-btn></v-col
                  >
                </v-row>
                <hr />
              </div> -->
              <div v-if="stateInfo.companiesCount != 0">
                <span class="pe-3 fs-medium c-dark"
                  >شرکت‌ها ({{ stateInfo.companiesCount }})</span
                >
                <v-row class="pt-3 px-2">
                  <v-col
                    cols="4"
                    v-for="(item, index) in stateInfo.companies.slice(0, 3)"
                    :key="index"
                    class="text-center"
                  >
                    <router-link :to="'companyProfile/' + item.id">
                      <img
                        class="item-img mx-auto"
                        :src="item.avatar ? item.avatar : '/companyLogo.png'"
                      />
                      <div
                        class="text-center fs-xsmall c-dark font-weight-bold"
                      >
                        {{ item.name }}
                      </div>
                    </router-link>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center pt-3">
                    <v-btn
                      @click="openModal('company')"
                      v-if="stateInfo.companiesCount > 3"
                      text
                      class="seeMore text-primary"
                    >
                      همه شرکت‌ها<v-icon class="px-2" color="primary"
                        >$ArrowLeft</v-icon
                      >
                    </v-btn></v-col
                  >
                </v-row>
                <hr />
              </div>
              <div v-if="stateInfo.organizationsCount != 0">
                <span class="pe-3 fs-medium c-dark"
                  >انجمن‌های دانشگاهی ({{ stateInfo.organizationsCount }})</span
                >
                <v-row class="pt-3 px-2">
                  <v-col
                    cols="4"
                    v-for="(item, index) in stateInfo.organizations.slice(0, 3)"
                    :key="index"
                    class="text-center"
                  >
                    <!-- <router-link :to="'companyProfile/' + item.id"> -->
                    <img
                      class="item-img mx-auto"
                      :src="item.avatar ? item.avatar : '/uniLogo.png'"
                    />
                    <div class="text-center fs-xsmall c-dark font-weight-bold">
                      {{ item.name }}
                    </div>
                    <!-- </router-link> -->
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center pt-3">
                    <v-btn
                      @click="openModal('organization')"
                      v-if="stateInfo.organizationsCount > 3"
                      text
                      class="seeMore text-primary"
                    >
                      همه انجمن‌ها<v-icon class="px-2" color="primary"
                        >$ArrowLeft</v-icon
                      >
                    </v-btn></v-col
                  >
                </v-row>
                <hr />
              </div>
              <div v-if="stateInfo.mehvarsCount != 0">
                <span class="pe-3 fs-medium c-dark"
                  >محور‌ها ({{ stateInfo.mehvarsCount }})</span
                >
                <v-row class="pt-3 px-2">
                  <v-col>
                    <div
                      class="mehvar-box mb-3"
                      v-for="(item, index) in stateInfo.mehvars.slice(0, 3)"
                      :key="index"
                    >
                      <div class="header d-flex flex-row">
                        <router-link
                          :to="'/universityProfile/' + item.universityId"
                        >
                          <img
                            class="item-img"
                            :src="
                              item.universityAvatar
                                ? item.universityAvatar
                                : '/uniLogo.png'
                            "
                          />
                          <span class="fs-small c-grey px-2 pt-2">
                            {{ item.universityname }}
                          </span>
                        </router-link>
                      </div>
                      <div class="pt-3">
                        <span class="fs-small c-grey px-1">{{
                          item.title
                        }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="stateInfo.mehvarsCount > 3">
                  <v-col class="text-center pt-0">
                    <v-btn
                      @click="openModal('mehvar')"
                      text
                      class="seeMore text-primary"
                    >
                      همه محور‌ها<v-icon class="px-2" color="primary"
                        >$ArrowLeft</v-icon
                      >
                    </v-btn></v-col
                  >
                </v-row>
              </div>
              <div v-if="stateInfo.chartHasData">
                <hr />
                <span class="pe-3 fs-medium c-dark">آمار حمایت‌ها</span>
                <div class="pt-2">
                  <Chart
                    name="barChart"
                    :chartdata="stateInfo.shortRequests"
                    :options="optionsBar"
                    type="bar"
                    :height="50"
                    :width="70"
                    v-if="loaded"
                  ></Chart>
                </div>
                <v-row>
                  <v-col class="text-center pt-3">
                    <v-btn
                      @click="openModal('chart')"
                      text
                      class="seeMore text-primary"
                    >
                      مشاهده بیشتر
                      <v-icon class="px-2" color="primary">$ArrowLeft</v-icon>
                    </v-btn></v-col
                  >
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-row>
      </v-navigation-drawer>
    </transition>

    <div class="main" :class="sidebar ? 'main-left' : ''">
      <v-tabs-items v-model="tab">
        <v-tab-item style="position: relative">
          <v-btn
            @click="mapInfoModal = true"
            class="mr-6 ms-6 mt-5 info-btn bc-primary white--text"
            elevation="0"
          >
            <v-icon class="pe-1"> mdi-information-outline </v-icon>

            راهنما</v-btn
          >
          <div
            v-if="!sidebar && deviceType == 'desktop'"
            style="position: absolute; right: 0px; top: 51%"
            class="map-bookmarks d-flex flex-column align-items-start"
          >
            <div @click="setadMissions = true" class="btn white--text mb-4">
              <div>ماموریت‌های ستاد</div>
            </div>
            <!-- <div @click="statesRoles = true" class="btn white--text mb-4">
              <div>نقش استان‌ها در توسعه زیست فناوری در کشور</div>
            </div> -->
          </div>

          <div class="map-info-panel">
            <div class="info-card" v-for="item in mapStats" :key="item.title">
              <div class="info-content">
                <div class="info-title">{{ item.title }}</div>
                <div class="info-value">
                  {{ Number(item.value).toLocaleString() }}
                </div>
              </div>
            </div>
          </div>

          <div class="map text-center w-100">
            <iran-map-vue
              :click="_clickMap"
              :hover="hoverMap"
              :ripple="true"
              @mouseleave.native="mapLeave()"
              :data="provinces"
              border-color="#c2c2c2"
              lake-color="#90CAF9"
              sea-color="#64B5F6"
              :width="
                deviceType == 'desktop' ? (sidebar ? '45%' : '40%') : '90%'
              "
              class="pointer animate__animated"
              :class="
                transition ? 'animate__fadeInLeft' : 'animate__fadeOutRight'
              "
              v-if="mapLoaded"
            />
            <looping-rhombuses-spinner
              :animation-duration="2500"
              :rhombus-size="15"
              color="#078d9d"
              v-else
            />
          </div>

          <div
            v-if="!sidebar && deviceType == 'desktop'"
            style="position: absolute; left: 0px; top: 21%"
            class="map-btns d-flex flex-column align-items-end"
          >
            <!-- <v-btn
              @click="
                selectedType = 'total';
                getData();
              "
              class="btn white--text mb-4"
              :class="selectedType == 'total' ? 'active' : ''"
              ><div>درخواست‌های ثبت شده</div></v-btn
            >
            <v-btn
              @click="
                selectedType = 'accepted ';
                getData();
              "
              class="btn white--text mb-4"
              :class="selectedType == 'accepted ' ? 'active' : ''"
              ><div>حمایت‌های تایید شده</div></v-btn
            > -->
            <v-btn
              @click="
                selectedType = 'university';
                getData();
              "
              class="btn white--text mb-4"
              :class="selectedType == 'university' ? 'active' : ''"
              ><div>دانشگاه‌ها</div></v-btn
            >
            <v-btn
              @click="
                selectedType = 'company';
                getData();
              "
              class="btn white--text mb-4"
              :class="selectedType == 'company' ? 'active' : ''"
              ><div>شرکت‌های دانش بنیان</div></v-btn
            >
            <v-btn
              @click="
                selectedType = 'mehvar';
                getData();
              "
              class="btn white--text mb-4"
              :class="selectedType == 'mehvar' ? 'active' : ''"
              ><div>محورها</div></v-btn
            >
          </div>
          <div class="map-btns" v-if="deviceType != 'desktop'">
            <v-row class="mx-4">
              <!-- <v-col cols="12">
                <v-btn
                  @click="
                    selectedType = 'total';
                    getData();
                  "
                  class="btn2 white--text mb-4"
                  :class="selectedType == 'total' ? 'active' : ''"
                  ><div>درخواست‌های ثبت شده</div></v-btn
                >
              </v-col>
              <v-col cols="6">
                <v-btn
                  @click="
                    selectedType = 'accepted ';
                    getData();
                  "
                  class="btn2 white--text mb-4"
                  :class="selectedType == 'accepted ' ? 'active' : ''"
                  ><div>حمایت‌های تایید شده</div></v-btn
                >
              </v-col> -->
              <v-col cols="6">
                <v-btn
                  @click="
                    selectedType = 'university';
                    getData();
                  "
                  class="btn2 white--text mb-4"
                  :class="selectedType == 'university' ? 'active' : ''"
                  ><div>دانشگاه‌ها</div></v-btn
                >
              </v-col>
              <v-col cols="6">
                <v-btn
                  @click="
                    selectedType = 'company';
                    getData();
                  "
                  class="btn2 white--text mb-4"
                  :class="selectedType == 'company' ? 'active' : ''"
                  ><div>شرکت‌های دانش بنیان</div></v-btn
                >
              </v-col>

              <v-col cols="6">
                <v-btn
                  @click="
                    selectedType = 'mehvar';
                    getData();
                  "
                  class="btn2 white--text mb-4"
                  :class="selectedType == 'mehvar' ? 'active' : ''"
                  ><div>محورها</div></v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div v-if="!catsLoading">
            <div v-if="cats.length != 0">
              <div class="pa-3">
                <v-row class="mt-5">
                  <v-col cols="9" class="mx-auto">
                    <v-row>
                      <v-col md="6" cols="12" class="d-flex align-items-center">
                        <v-btn
                          @click="catInfoModal = true"
                          class="info-btn bc-primary white--text"
                          elevation="0"
                        >
                          <v-icon class="pe-1">
                            mdi-information-outline
                          </v-icon>

                          راهنما</v-btn
                        ></v-col
                      >
                      <v-col md="6" cols="12" class="pe-0">
                        <div class="float-end">
                          <v-text-field
                            v-if="filterType == 'title'"
                            rounded
                            filled
                            class="search-box"
                            placeholder="جستجو در موضوعات..."
                            v-model="titlesFilter"
                            @input="currentPage = 1"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon class="ps-3">$searchIcon</v-icon>
                            </template>
                          </v-text-field>
                        </div></v-col
                      >
                    </v-row>
                  </v-col>
                </v-row>
                <div v-if="computedCats.length" class="mt-2">
                  <v-row>
                    <v-col
                      class="mx-auto pt-0"
                      cols="12"
                      sm="12"
                      md="9"
                      lg="9"
                      v-for="(item, index) in computedCats"
                      :key="index"
                    >
                      <div
                        class="selectedTab-box d-flex pa-4 pointer"
                        :class="
                          chosenCategory.id == item.id ? 'selectedCat-box' : ''
                        "
                        @click="chooseCategory(item)"
                      >
                        <v-row>
                          <v-col>
                            <div class="d-flex align-center">
                              <span class="ms-3 font-weight-bold fs-small">{{
                                item.name
                              }}</span>
                            </div></v-col
                          >
                          <v-col class="text-end pe-5 mt-1"
                            ><span class="mb-5 fs-small"
                              >{{ item.universityCounts }} دانشگاه</span
                            ></v-col
                          >
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="mx-auto mt-3 mb-10 pag-row">
                    <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                      <v-row class="mt-2 select-col">
                        <span class="mt-1 c-grey">تعداد در هر صفحه</span>
                        <v-select
                          v-model="perPage"
                          :options="perPageOptions"
                          class="me-2 ms-2 select-field"
                          style="max-width: 80px"
                          @input="calCurrent"
                        >
                        </v-select>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="6"
                      lg="6"
                      xl="6"
                      class="pag-col"
                    >
                      <v-pagination
                        v-model="currentPage"
                        :length="
                          Math.ceil(
                            cats.filter((x) => x.name.includes(titlesFilter))
                              .length / perPage
                          )
                        "
                        @input="oldCurrentPage = currentPage"
                        prev-icon="chevron_left"
                        next-icon="chevron_right"
                        class="float-end"
                        :total-visible="5"
                      ></v-pagination>
                    </v-col>
                  </v-row>
                </div>
                <div v-else>
                  <v-row>
                    <v-col
                      class="mx-auto text-center"
                      cols="12"
                      sm="12"
                      md="9"
                      lg="9"
                    >
                      <div class="selectedTab-box pa-8">
                        <h5>موردی برای نمایش وجود ندارد.</h5>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
            <div v-else>
              <v-row class="justify-content-center pa-5 mt-10">
                <hr />
                <h6 class="fs-small c-grey">موردی برای نمایش وجود ندارد.</h6>
                <hr />
              </v-row>
            </div>
          </div>
          <div
            v-else
            class="d-flex flex-column justify-content-center align-items-center mt-16 pa-5"
          >
            <looping-rhombuses-spinner
              :animation-duration="2500"
              :rhombus-size="15"
              color="#078d9d"
            />
            <h5 class="mt-5 font-weight-bold">در حال بارگذاری...</h5>
          </div>
        </v-tab-item>
        <!-- inja -->
        <v-tab-item>
          <v-btn
            v-if="!largeScreen"
            @click="mehvarInfoModal = true"
            class="mr-6 ms-6 mt-5 info-btn bc-primary white--text"
            elevation="0"
          >
            <v-icon class="pe-1"> mdi-information-outline </v-icon>

            راهنما</v-btn
          >
          <div v-if="mehvars.length != 0">
            <div class="pa-3">
              <v-row class="mt-5">
                <v-col cols="9" class="mx-auto">
                  <div v-if="largeScreen">
                    <div class="info-box mt-6" v-if="showInfo">
                      <div class="icon-box">
                        <v-icon class="me-2 white--text" large
                          >mdi-message-alert-outline</v-icon
                        >
                        <h5>راهنما</h5>
                      </div>
                      <div
                        class="text-box"
                        :class="showInfo ? 'text-box-show' : ''"
                      >
                        <div class="h5-box">
                          <span class="mt-2">
                            کاربر گرامی، برای انتخاب محور‌های موردنظر، ابتدا نام
                            محور را جستجو کنید و پس از انتخاب محور‌ها بر روی
                            دکمه مشاهده جزئیات محور‌ها کلیک کنید.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <v-row>
                    <v-col cols="12" sm="12" md="7">
                      <div>
                        <v-text-field
                          v-if="filterType == 'mehvar'"
                          rounded
                          filled
                          class="search-box"
                          placeholder="جستجو در محورها..."
                          v-model="mehvarsFilter"
                          @input="mehvarTabCurrentPage = 1"
                          hide-details
                        >
                          <template v-slot:prepend-inner>
                            <v-icon class="ps-3">$searchIcon</v-icon>
                          </template>
                        </v-text-field>
                      </div></v-col
                    >
                    <v-col class="text-end" cols="12" sm="12" md="5">
                      <v-btn
                        @click="
                          getMehvarsReport();
                          showInfo = false;
                        "
                        class="mr-6 ms-6 mt-10 bc-primary white--text"
                        style="box-shadow: none"
                        :disabled="!selectedMehvars.length"
                      >
                        <v-icon class="pe-1"> mdi-chart-box-outline </v-icon>
                        مشاهده جزییات محور‌ها</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="9" class="mx-auto">
                  <v-row>
                    <v-col cols="12">
                      <div class="d-flex justify-space-between flex-wrap">
                        <h5 class="mt-2">
                          <v-icon class="me-1" color="#068d9d"
                            >mdi-message-alert-outline</v-icon
                          >
                          حداکثر تعداد محور قابل انتخاب برای گزارش‌گیری ۱۰ عدد
                          است.
                          <span style="color: #068d9d">
                            (تعداد انتخاب شده: {{ selectedMehvars.length }})
                          </span>
                        </h5>
                        <!--<v-btn
                        :outlined="
                          computedMehvars2.length == selectedMehvars.length
                            ? false
                            : true
                        "
                        color="#068d9d"
                        :class="
                          computedMehvars2.length == selectedMehvars.length
                            ? 'white--text'
                            : ''
                        "
                        @click="selectAllMehvars()"
                        :disabled="
                          computedMehvars2.length == selectedMehvars.length
                        "
                      >
                        انتخاب همه
                      </v-btn>-->

                        <v-btn
                          class="bc-red white--text ms-2"
                          @click="clearAllMehvars()"
                          :disabled="!selectedMehvars.length"
                        >
                          حذف همه
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="mx-auto pb-0" cols="12" sm="12" md="9" lg="9">
                  <v-row class="mt-5">
                    <v-col class="text-center"
                      ><span
                        class="font-weight-bold blue-grey--text text--darken-2 fs-medium"
                      >
                        نام محور
                      </span></v-col
                    >
                    <v-col class="text-center"
                      ><span
                        class="font-weight-bold blue-grey--text text--darken-2 fs-medium"
                      >
                        موضوع
                      </span></v-col
                    >
                    <v-col class="text-center"
                      ><span
                        class="font-weight-bold blue-grey--text text--darken-2 fs-medium"
                      >
                        دانشگاه
                      </span></v-col
                    >
                  </v-row>
                  <hr />
                </v-col>
              </v-row>
              <div v-if="computedMehvars.length" class="mt-2">
                <v-row>
                  <v-col
                    class="mx-auto pt-0"
                    cols="12"
                    md="9"
                    v-for="(item, index) in computedMehvars"
                    :key="index"
                  >
                    <div
                      class="selectedTab-box d-flex pa-4"
                      :class="
                        selectedMehvars.includes(item.name)
                          ? 'selectedRow-box'
                          : ''
                      "
                      @click="selectMehvarFunc(item)"
                      :style="
                        selectedMehvars.includes(item.name)
                          ? 'cursor:pointer'
                          : !checkMehvarCount
                          ? 'cursor:pointer'
                          : ''
                      "
                    >
                      <v-row>
                        <v-col>
                          <div class="d-flex align-center">
                            <v-icon
                              large
                              :color="
                                selectedMehvars.includes(item.name)
                                  ? '#068d9d'
                                  : !checkMehvarCount
                                  ? '#068d9d'
                                  : 'grey'
                              "
                            >
                              {{
                                selectedMehvars.includes(item.name)
                                  ? "mdi-checkbox-marked-outline"
                                  : "mdi-checkbox-blank-outline"
                              }}
                            </v-icon>
                            <span class="ms-3 font-weight-bold fs-small">{{
                              item.name
                            }}</span>
                          </div></v-col
                        >
                        <v-col class="text-center"
                          ><span class="mb-5 fs-small">{{
                            item.catName
                          }}</span></v-col
                        >
                        <v-col class="text-center"
                          ><span class="mb-5 fs-small">{{
                            item.universityName
                          }}</span></v-col
                        >
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="mx-auto mt-3 mb-10 pag-row">
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                    <v-row class="mt-2 select-col">
                      <span class="mt-1 c-grey">تعداد در هر صفحه</span>
                      <v-select
                        v-model="mehvarTabPerPage"
                        :options="perPageOptions"
                        class="me-2 ms-2 select-field"
                        style="max-width: 80px"
                        @input="mehvarTabCurrentPage = 1"
                      >
                      </v-select>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pag-col">
                    <v-pagination
                      v-model="mehvarTabCurrentPage"
                      :length="
                        Math.ceil(
                          mehvars.filter((x) => x.name.includes(mehvarsFilter))
                            .length / mehvarTabPerPage
                        )
                      "
                      @input="oldMehvarTabCurrentPage = mehvarTabCurrentPage"
                      prev-icon="chevron_left"
                      next-icon="chevron_right"
                      class="float-end"
                      :total-visible="5"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </div>
              <div v-else>
                <v-row>
                  <v-col
                    class="mx-auto text-center"
                    cols="12"
                    sm="12"
                    md="9"
                    lg="9"
                  >
                    <div class="selectedTab-box pa-8">
                      <h5>موردی برای نمایش وجود ندارد.</h5>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
          <div v-else>
            <v-row class="justify-content-center pa-5 mt-10">
              <hr />
              <h6 class="fs-small c-grey">موردی برای نمایش وجود ندارد.</h6>
              <hr />
            </v-row>
          </div>
        </v-tab-item>
        <!-- <v-tab-item>
          <div v-if="allAccelerators.length != 0">
            <v-row class="mt-5">
              <v-col cols="9" class="mx-auto">
                <v-row>
                  <v-col md="6" cols="12" class="d-flex align-items-center">
                    <v-btn
                      @click="acceleratorInfoModal = true"
                      class="info-btn bc-primary white--text"
                      elevation="0"
                    >
                      <v-icon class="pe-1"> mdi-information-outline </v-icon>

                      راهنما</v-btn
                    ></v-col
                  >
                  <v-col md="6" cols="12" class="pe-0">
                    <div class="float-end">
                      <v-text-field
                        v-if="filterType == 'accelerators'"
                        rounded
                        filled
                        class="search-box"
                        placeholder="جستجو در نام شتاب‌دهنده..."
                        @input="acceleratorsCurrentPage = 1"
                        v-model="acceleratorsFilter"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon class="ps-3">$searchIcon</v-icon>
                        </template>
                      </v-text-field>
                    </div></v-col
                  >
                </v-row>
              </v-col>
            </v-row>
            <div class="pa-3">
              <v-row>
                <v-col
                  class="mx-auto titles-list"
                  cols="12"
                  sm="12"
                  md="9"
                  lg="9"
                >
                  <b-table
                    tbody-tr-class="trClass"
                    thead-class="company_header"
                    hover
                    responsive
                    small
                    ref="mytable"
                    :current-page="acceleratorsCurrentPage"
                    :per-page="acceleratorsPerPage"
                    :items="computedAccelerators"
                    :fields="acceleratorsFields"
                    :busy="acceleratorsTableBusy"
                    @row-selected="acceleratorOnRowSelected"
                    selectable
                    select-mode="single"
                    empty-filtered-text="موردی برای نمایش وجود ندارد"
                    empty-text="موردی برای نمایش وجود ندارد"
                    show-empty
                  >
                    <template v-slot:cell(catName)="data">
                      <div style="text-align: right; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(products)="data">
                      <div
                        style="
                          text-align: right;
                          vertical-align: middle;
                          min-width: 350px;
                        "
                      >
                        <div v-if="data.value.length != 0">
                          <li v-for="(item, index) in data.value" :key="index">
                            <v-icon>mdi-circle-small</v-icon>
                            {{ item.title }}
                          </li>
                        </div>
                        <div v-else>-</div>
                      </div>
                    </template>
                  </b-table>
                </v-col>
              </v-row>

              <v-row class="mx-auto mt-3 mb-10 pag-row">
                <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                  <v-row class="mt-2 select-col">
                    <span class="mt-1 c-grey">تعداد در هر صفحه</span>
                    <v-select
                      v-model="acceleratorsPerPage"
                      :options="perPageOptions"
                      @input="calAcceleratorsCurrent"
                      class="me-2 ms-2 select-field"
                      style="max-width: 80px"
                    >
                    </v-select>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pag-col">
                  <v-pagination
                    v-model="acceleratorsCurrentPage"
                    :length="
                      Math.ceil(
                        computedAccelerators.length / acceleratorsPerPage
                      )
                    "
                    @input="
                      oldAcceleratorsCurrentPage = acceleratorsCurrentPage
                    "
                    prev-icon="chevron_left"
                    next-icon="chevron_right"
                    class="float-end"
                  ></v-pagination>
                </v-col>
              </v-row>
            </div>
          </div>
          <div v-else>
            <v-row class="justify-content-center pa-5 mt-10">
              <hr />
              <h6 class="fs-small c-grey">موردی برای نمایش وجود ندارد.</h6>
              <hr />
            </v-row>
          </div>
        </v-tab-item> -->
        <v-tab-item>
          <div v-if="companies.length != 0">
            <v-row class="mt-5">
              <v-col cols="9" class="mx-auto">
                <v-row>
                  <v-col md="6" cols="12" class="d-flex align-items-center">
                    <v-btn
                      @click="companyInfoModal = true"
                      class="info-btn bc-primary white--text"
                      elevation="0"
                    >
                      <v-icon class="pe-1"> mdi-information-outline </v-icon>

                      راهنما</v-btn
                    ></v-col
                  >
                  <v-col md="6" cols="12" class="pe-0">
                    <div class="float-end">
                      <v-text-field
                        v-if="filterType == 'companies'"
                        rounded
                        filled
                        class="search-box"
                        placeholder="جستجو در نام شرکت..."
                        @input="companiesCurrentPage = 1"
                        v-model="companiesFilter"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon class="ps-3">$searchIcon</v-icon>
                        </template>
                      </v-text-field>
                    </div></v-col
                  >
                </v-row>
              </v-col>
            </v-row>
            <div class="pa-3">
              <v-row>
                <v-col
                  class="mx-auto titles-list"
                  cols="12"
                  sm="12"
                  md="9"
                  lg="9"
                >
                  <b-table
                    tbody-tr-class="trClass"
                    thead-class="company_header"
                    hover
                    responsive
                    small
                    ref="mytable"
                    :current-page="companiesCurrentPage"
                    :per-page="companiesPerPage"
                    :items="computedCompanies"
                    :fields="companiesFields"
                    :busy="companiesTableBusy"
                    @row-selected="companyOnRowSelected"
                    selectable
                    select-mode="single"
                    empty-filtered-text="موردی برای نمایش وجود ندارد"
                    empty-text="موردی برای نمایش وجود ندارد"
                    show-empty
                  >
                    <template v-slot:cell(products)="data">
                      <div
                        style="
                          text-align: right;
                          vertical-align: middle;
                          min-width: 350px !important;
                        "
                      >
                        <div v-if="data.value.length != 0">
                          <li v-for="(item, index) in data.value" :key="index">
                            <v-icon>mdi-circle-small</v-icon>
                            {{ item.title }}
                          </li>
                        </div>
                        <div v-else>-</div>
                      </div>
                    </template>
                  </b-table>
                </v-col>
              </v-row>

              <v-row class="mx-auto mt-3 mb-10 pag-row">
                <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                  <v-row class="mt-2 select-col">
                    <span class="mt-1 c-grey">تعداد در هر صفحه</span>
                    <v-select
                      v-model="companiesPerPage"
                      :options="perPageOptions"
                      @input="calCompaniesCurrent"
                      class="me-2 ms-2 select-field"
                      style="max-width: 80px"
                    >
                    </v-select>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pag-col">
                  <v-pagination
                    v-model="companiesCurrentPage"
                    :length="
                      Math.ceil(computedCompanies.length / companiesPerPage)
                    "
                    @input="oldCompaniesCurrentPage = companiesCurrentPage"
                    prev-icon="chevron_left"
                    next-icon="chevron_right"
                    class="float-end"
                  ></v-pagination>
                </v-col>
              </v-row>
            </div>
          </div>
          <div v-else>
            <v-row class="justify-content-center pa-5 mt-10">
              <hr />
              <h6 class="fs-small c-grey">موردی برای نمایش وجود ندارد.</h6>
              <hr />
            </v-row>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div v-if="organizations.length != 0">
            <v-row class="mt-5">
              <v-col cols="9" class="mx-auto">
                <v-row>
                  <v-col md="6" cols="12" class="d-flex align-items-center">
                    <v-btn
                      @click="organizationInfoModal = true"
                      class="info-btn bc-primary white--text"
                      elevation="0"
                    >
                      <v-icon class="pe-1"> mdi-information-outline </v-icon>

                      راهنما</v-btn
                    ></v-col
                  >
                  <v-col md="6" cols="12" class="pe-0">
                    <div class="float-end">
                      <v-text-field
                        v-if="filterType == 'organizations'"
                        rounded
                        filled
                        class="search-box"
                        placeholder="جستجو در نام انجمن..."
                        @input="organizationsCurrentPage = 1"
                        v-model="organizationsFilter"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon class="ps-3">$searchIcon</v-icon>
                        </template>
                      </v-text-field>
                    </div></v-col
                  >
                </v-row>
              </v-col>
            </v-row>
            <div class="pa-3">
              <v-row>
                <v-col
                  class="mx-auto titles-list"
                  cols="12"
                  sm="12"
                  md="9"
                  lg="9"
                >
                  <b-table
                    tbody-tr-class="trClass"
                    thead-class="company_header"
                    hover
                    responsive
                    small
                    ref="mytable"
                    :current-page="organizationsCurrentPage"
                    :per-page="organizationsPerPage"
                    :items="computedOrganizations"
                    :fields="organizationsFields"
                    :busy="organizationsTableBusy"
                    selectable
                    select-mode="single"
                    empty-filtered-text="موردی برای نمایش وجود ندارد"
                    empty-text="موردی برای نمایش وجود ندارد"
                    show-empty
                  >
                    <template v-slot:cell(products)="data">
                      <div
                        style="
                          text-align: right;
                          vertical-align: middle;
                          min-width: 350px !important;
                        "
                      >
                        <div v-if="data.value.length != 0">
                          <li v-for="(item, index) in data.value" :key="index">
                            <v-icon>mdi-circle-small</v-icon>
                            {{ item.title }}
                          </li>
                        </div>
                        <div v-else>-</div>
                      </div>
                    </template>
                  </b-table>
                </v-col>
              </v-row>

              <v-row class="mx-auto mt-3 mb-10 pag-row">
                <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                  <v-row class="mt-2 select-col">
                    <span class="mt-1 c-grey">تعداد در هر صفحه</span>
                    <v-select
                      v-model="organizationsPerPage"
                      :options="perPageOptions"
                      @input="calOrganizationsCurrent"
                      class="me-2 ms-2 select-field"
                      style="max-width: 80px"
                    >
                    </v-select>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pag-col">
                  <v-pagination
                    v-model="organizationsCurrentPage"
                    :length="
                      Math.ceil(
                        computedOrganizations.length / organizationsPerPage
                      )
                    "
                    @input="
                      oldOrganizationsCurrentPage = organizationsCurrentPage
                    "
                    prev-icon="chevron_left"
                    next-icon="chevron_right"
                    class="float-end"
                  ></v-pagination>
                </v-col>
              </v-row>
            </div>
          </div>
          <div v-else>
            <v-row class="justify-content-center pa-5 mt-10">
              <hr />
              <h6 class="fs-small c-grey">موردی برای نمایش وجود ندارد.</h6>
              <hr />
            </v-row>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <v-dialog v-model="chooseMehvarDialog" width="600">
      <v-card class="map-modalCard pa-6">
        <v-row>
          <v-col class="text-end mt-3 py-0">
            <v-icon class="pointer" @click="chooseMehvarDialog = false"
              >$Close</v-icon
            >
          </v-col>
        </v-row>
        <div>
          <v-row>
            <v-col class="text-center pa-5">
              <v-icon class="me-2 primary--text"
                >mdi-message-alert-outline</v-icon
              >
              <span class="c-grey fs-large font-weight-bold">
                کاربر گرامی، بیشتر از ۱۰ محور نمی‌توانید انتخاب کنید.
              </span>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="universitiesModal" width="700">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right mt-2">
              <span v-if="fromProfiles" class="fs-xlarge c-dark"
                >دانشگاه‌ها<span v-if="filterType == 'city'"
                  >ی استان {{ selectedState }}</span
                ></span
              >
              <span v-else class="fs-xlarge c-dark"
                >دانشگاه‌ها<span v-if="filterType == 'city' && selectedCity.key"
                  >ی استان {{ selectedCity.mapData.name }}</span
                ></span
              >
            </v-col>
            <v-col v-if="deviceType != 'mobile'">
              <v-text-field
                rounded
                filled
                class="search-box"
                placeholder="جستجو در دانشگاه‌ها..."
                v-model="filterUni"
                ><template v-slot:prepend-inner>
                  <v-icon class="ps-1">$searchIcon</v-icon>
                </template></v-text-field
              ></v-col
            >
            <v-col
              class="text-left mt-3"
              :cols="deviceType == 'mobile' ? '2' : '1'"
            >
              <span @click="universitiesModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-row v-if="deviceType == 'mobile'">
            <v-col>
              <v-text-field
                rounded
                filled
                class="search-box"
                placeholder="جستجو در دانشگاه‌ها..."
                v-model="filterUni"
                ><template v-slot:prepend-inner>
                  <v-icon class="ps-1">$searchIcon</v-icon>
                </template></v-text-field
              >
            </v-col>
          </v-row>
          <v-row v-if="filterType == 'title' && selectedTitle.length">
            <v-col class="py-0">
              <span class="c-dark fs-medium">{{ selectedTitle[0].title }}</span>
            </v-col>
          </v-row>
          <div v-if="loaded2">
            <v-row v-if="!uniFilteredList.length">
              <v-col class="text-center pa-5">
                <span class="c-grey fs-small">
                  <hr />
                  موردی برای نمایش وجود ندارد.
                  <hr />
                </span>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                md="3"
                sm="4"
                cols="6"
                v-for="(item, index) in uniFilteredList"
                :key="index"
              >
                <router-link :to="'universityProfile/' + item.id">
                  <div class="text-center">
                    <img
                      class="item-img"
                      :src="item.avatar ? item.avatar : '/uniLogo.png'"
                    />
                    <p class="c-dark font-weight-bold">{{ item.name }}</p>
                  </div>
                </router-link>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="distinguishedUniModal" width="700">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right mt-2">
              <span v-if="fromProfiles" class="fs-xlarge c-dark"
                >دانشگاه‌ها<span v-if="filterType == 'city'"
                  >ی برتر استان {{ selectedState }}</span
                ></span
              >
              <span v-else class="fs-xlarge c-dark"
                >دانشگاه‌ها<span v-if="filterType == 'city' && selectedCity.key"
                  >ی برتر استان {{ selectedCity.mapData.name }}</span
                ></span
              >
            </v-col>
            <v-col v-if="deviceType != 'mobile'">
              <v-text-field
                rounded
                filled
                class="search-box"
                placeholder="جستجو در دانشگاه‌ها..."
                v-model="filterDistinguished"
                ><template v-slot:prepend-inner>
                  <v-icon class="ps-1">$searchIcon</v-icon>
                </template></v-text-field
              ></v-col
            >
            <v-col
              class="text-left mt-3"
              :cols="deviceType == 'mobile' ? '2' : '1'"
            >
              <span @click="distinguishedUniModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-row v-if="deviceType == 'mobile'">
            <v-col>
              <v-text-field
                rounded
                filled
                class="search-box"
                placeholder="جستجو در دانشگاه‌ها..."
                v-model="filterDistinguished"
                ><template v-slot:prepend-inner>
                  <v-icon class="ps-1">$searchIcon</v-icon>
                </template></v-text-field
              >
            </v-col>
          </v-row>
          <v-row v-if="filterType == 'title' && selectedTitle.length">
            <v-col class="py-0">
              <span class="c-dark fs-medium">{{ selectedTitle[0].title }}</span>
            </v-col>
          </v-row>
          <div v-if="loaded2">
            <v-row v-if="!distinguishedFilteredList.length">
              <v-col class="text-center pa-5">
                <span class="c-grey fs-small">
                  <hr />
                  موردی برای نمایش وجود ندارد.
                  <hr />
                </span>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                md="3"
                sm="4"
                cols="6"
                v-for="(item, index) in distinguishedFilteredList"
                :key="index"
              >
                <router-link :to="'universityProfile/' + item.id">
                  <div class="text-center">
                    <img
                      class="item-img"
                      :src="item.avatar ? item.avatar : '/uniDisLogo.png'"
                    />
                    <p class="c-dark font-weight-bold">{{ item.name }}</p>
                  </div>
                </router-link>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="researcherModal" width="700">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right mt-2">
              <span v-if="fromProfiles" class="fs-xlarge c-dark"
                >پژوهشگران برتر<span v-if="filterType == 'city'">
                  استان {{ selectedState }}</span
                ></span
              >
              <span v-else class="fs-xlarge c-dark"
                >پژوهشگران برتر<span
                  v-if="filterType == 'city' && selectedCity.key"
                >
                  استان {{ selectedCity.mapData.name }}</span
                ></span
              >
            </v-col>
            <v-col v-if="deviceType != 'mobile'">
              <v-text-field
                rounded
                filled
                class="search-box"
                placeholder="جستجو در پژوهشگران..."
                v-model="filterResearcher"
                ><template v-slot:prepend-inner>
                  <v-icon class="ps-1">$searchIcon</v-icon>
                </template></v-text-field
              ></v-col
            >
            <v-col
              class="text-left mt-3"
              :cols="deviceType == 'mobile' ? '2' : '1'"
            >
              <span @click="researcherModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-row v-if="deviceType == 'mobile'">
            <v-col>
              <v-text-field
                rounded
                filled
                class="search-box"
                placeholder="جستجو در پژوهشگران..."
                v-model="filterResearcher"
                ><template v-slot:prepend-inner>
                  <v-icon class="ps-1">$searchIcon</v-icon>
                </template></v-text-field
              >
            </v-col>
          </v-row>
          <v-row v-if="filterType == 'title' && selectedTitle.length">
            <v-col class="py-0">
              <span class="c-dark fs-medium">{{ selectedTitle[0].title }}</span>
            </v-col>
          </v-row>
          <div v-if="loaded2">
            <v-row v-if="!researcherFilteredList.length">
              <v-col class="text-center pa-5">
                <span class="c-grey fs-small">
                  <hr />
                  موردی برای نمایش وجود ندارد.
                  <hr />
                </span>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                md="3"
                sm="4"
                cols="6"
                v-for="(item, index) in researcherFilteredList"
                :key="index"
              >
                <router-link :to="'researcherProfile/' + item.id">
                  <div class="text-center">
                    <img
                      class="item-img"
                      :src="item.avatar ? item.avatar : '/researcherLogo.png'"
                    />
                    <p class="c-dark font-weight-bold">{{ item.name }}</p>
                  </div>
                </router-link>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="acceleratorsModal" width="700">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right mt-2">
              <span v-if="fromProfiles" class="fs-xlarge c-dark"
                >شتاب‌دهنده‌ها<span v-if="filterType == 'city'"
                  >ی استان {{ selectedState }}</span
                ></span
              >
              <span v-else class="fs-xlarge c-dark"
                >شتاب‌دهنده‌ها<span
                  v-if="filterType == 'city' && selectedCity.key"
                  >ی استان {{ selectedCity.mapData.name }}</span
                ></span
              >
            </v-col>
            <v-col v-if="deviceType != 'mobile'">
              <v-text-field
                rounded
                filled
                class="search-box"
                placeholder="جستجو در شتاب‌دهنده‌ها..."
                v-model="filterAccelerator"
                ><template v-slot:prepend-inner>
                  <v-icon class="ps-1">$searchIcon</v-icon>
                </template></v-text-field
              ></v-col
            >
            <v-col
              class="text-left mt-3"
              :cols="deviceType == 'mobile' ? '2' : '1'"
            >
              <span @click="acceleratorsModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-row v-if="deviceType == 'mobile'">
            <v-col>
              <v-text-field
                rounded
                filled
                class="search-box"
                placeholder="جستجو در دانشگاه‌ها..."
                v-model="filterAccelerator"
                ><template v-slot:prepend-inner>
                  <v-icon class="ps-1">$searchIcon</v-icon>
                </template></v-text-field
              >
            </v-col>
          </v-row>
          <v-row v-if="filterType == 'title' && selectedTitle.length">
            <v-col class="py-0">
              <span class="c-dark fs-medium">{{ selectedTitle[0].title }}</span>
            </v-col>
          </v-row>
          <div v-if="loaded4">
            <v-row v-if="!acceleratorFilteredList.length">
              <v-col class="text-center pa-5">
                <span class="c-grey fs-small">
                  <hr />
                  موردی برای نمایش وجود ندارد.
                  <hr />
                </span>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                md="3"
                sm="4"
                cols="6"
                v-for="(item, index) in acceleratorFilteredList"
                :key="index"
              >
                <router-link :to="'acceleratorProfile/' + item.id">
                  <div class="text-center">
                    <img
                      class="item-img"
                      :src="item.avatar ? item.avatar : '/companyLogo.png'"
                    />
                    <p class="c-dark font-weight-bold">{{ item.name }}</p>
                  </div>
                </router-link>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-dialog> -->
    <v-dialog v-model="companiesModal" width="700">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right mt-2">
              <span v-if="fromProfiles" class="fs-xlarge c-dark"
                >شرکت‌ها<span v-if="filterType == 'city'"
                  >ی استان {{ selectedState }}</span
                ></span
              >
              <span v-else class="fs-xlarge c-dark"
                >شرکت‌ها<span v-if="filterType == 'city' && selectedCity.key"
                  >ی استان {{ selectedCity.mapData.name }}</span
                ></span
              >
            </v-col>
            <v-col v-if="deviceType != 'mobile'">
              <v-text-field
                rounded
                filled
                class="search-box"
                placeholder="جستجو در شرکت‌ها..."
                v-model="filterCompany"
                ><template v-slot:prepend-inner>
                  <v-icon class="ps-1">$searchIcon</v-icon>
                </template></v-text-field
              ></v-col
            >
            <v-col
              class="text-left mt-3"
              :cols="deviceType == 'mobile' ? '2' : '1'"
            >
              <span @click="companiesModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-row v-if="deviceType == 'mobile'">
            <v-col>
              <v-text-field
                rounded
                filled
                class="search-box"
                placeholder="جستجو در دانشگاه‌ها..."
                v-model="filterCompany"
                ><template v-slot:prepend-inner>
                  <v-icon class="ps-1">$searchIcon</v-icon>
                </template></v-text-field
              >
            </v-col>
          </v-row>
          <v-row v-if="filterType == 'title' && selectedTitle.length">
            <v-col class="py-0">
              <span class="c-dark fs-medium">{{ selectedTitle[0].title }}</span>
            </v-col>
          </v-row>
          <div v-if="loaded3">
            <v-row v-if="!companyFilteredList.length">
              <v-col class="text-center pa-5">
                <span class="c-grey fs-small">
                  <hr />
                  موردی برای نمایش وجود ندارد.
                  <hr />
                </span>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                md="3"
                sm="4"
                cols="6"
                v-for="(item, index) in companyFilteredList"
                :key="index"
              >
                <router-link :to="'companyProfile/' + item.id">
                  <div class="text-center">
                    <img
                      class="item-img"
                      :src="item.avatar ? item.avatar : '/companyLogo.png'"
                    />
                    <p class="c-dark font-weight-bold">{{ item.name }}</p>
                  </div>
                </router-link>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="organizationsModal" width="700">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right mt-2">
              <span v-if="fromProfiles" class="fs-xlarge c-dark"
                >انجمن‌های دانشگاهی<span v-if="filterType == 'city'">
                  استان {{ selectedState }}</span
                ></span
              >
              <span v-else class="fs-xlarge c-dark"
                >انجمن‌های دانشگاهی<span
                  v-if="filterType == 'city' && selectedCity.key"
                >
                  استان {{ selectedCity.mapData.name }}</span
                ></span
              >
            </v-col>
            <v-col v-if="deviceType != 'mobile'">
              <v-text-field
                rounded
                filled
                class="search-box"
                placeholder="جستجو در انجمن‌ها..."
                v-model="filterOrganiation"
                ><template v-slot:prepend-inner>
                  <v-icon class="ps-1">$searchIcon</v-icon>
                </template></v-text-field
              ></v-col
            >
            <v-col
              class="text-left mt-3"
              :cols="deviceType == 'mobile' ? '2' : '1'"
            >
              <span @click="organizationsModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-row v-if="deviceType == 'mobile'">
            <v-col>
              <v-text-field
                rounded
                filled
                class="search-box"
                placeholder="جستجو در دانشگاه‌ها..."
                v-model="filterOrganiation"
                ><template v-slot:prepend-inner>
                  <v-icon class="ps-1">$searchIcon</v-icon>
                </template></v-text-field
              >
            </v-col>
          </v-row>
          <v-row v-if="filterType == 'title' && selectedTitle.length">
            <v-col class="py-0">
              <span class="c-dark fs-medium">{{ selectedTitle[0].title }}</span>
            </v-col>
          </v-row>
          <div v-if="loaded3">
            <v-row v-if="!organizationFilteredList.length">
              <v-col class="text-center pa-5">
                <span class="c-grey fs-small">
                  <hr />
                  موردی برای نمایش وجود ندارد.
                  <hr />
                </span>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                md="3"
                sm="4"
                cols="6"
                v-for="(item, index) in organizationFilteredList"
                :key="index"
              >
                <!-- <router-link :to="'companyProfile/' + item.id"> -->
                <div class="text-center">
                  <img
                    class="item-img"
                    :src="item.avatar ? item.avatar : '/companyLogo.png'"
                  />
                  <p class="c-dark font-weight-bold">{{ item.name }}</p>
                </div>
                <!-- </router-link> -->
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mehvarsModal" width="700">
      <v-card class="map-modalCard p-2">
        <v-container v-if="stateInfo.mehvars">
          <v-row>
            <v-col class="text-right">
              <span class="fs-xlarge c-dark">محورها</span>
            </v-col>
            <v-col class="text-left">
              <span @click="mehvarsModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-row v-if="filterType == 'title' && selectedTitle.length">
            <v-col class="pb-2">
              <span class="c-dark fs-medium">{{ selectedTitle[0].title }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="4" cols="12" v-if="filterType == 'city'">
              <div v-if="fromProfiles">
                <p class="fs-large c-dark pt-2 mb-0">
                  استان {{ selectedState }}
                </p>
              </div>
              <div v-else>
                <p v-if="selectedCity.key" class="fs-large c-dark pt-2 mb-0">
                  استان {{ selectedCity.mapData.name }}
                </p>
              </div>
            </v-col>
            <v-col>
              <v-text-field
                rounded
                filled
                class="search-box"
                placeholder="جستجو در محور‌ها..."
                v-model="filterMehvar"
                ><template v-slot:prepend-inner>
                  <v-icon class="ps-3">$searchIcon</v-icon>
                </template></v-text-field
              >
            </v-col>
          </v-row>
          <div>
            <b-table
              tbody-tr-class="trClass"
              thead-class="hidden_header"
              hover
              responsive
              small
              empty-filtered-text="موردی برای نمایش وجود ندارد"
              empty-text="موردی برای نمایش وجود ندارد"
              show-empty
              :filter="filterMehvar"
              :fields="mehvarFields"
              :current-page="mehvarsCurrentPage"
              :per-page="mehvarsPerPage"
              :items="stateInfo.mehvars"
              @filtered="mehvarOnFiltered"
            >
              <template v-slot:cell(universityname)="data">
                <div
                  style="
                    text-align: left;
                    vertical-align: middle;
                    min-width: 100px;
                  "
                >
                  <router-link
                    :to="'universityProfile/' + data.item.universityId"
                  >
                    ({{ data.value }})
                  </router-link>
                </div>
              </template></b-table
            >
          </div>
          <v-row class="my-2">
            <v-col class="text-center">
              <v-pagination
                v-model="mehvarsCurrentPage"
                :length="Math.ceil(mehvarTotalRows / mehvarsPerPage)"
                :total-visible="5"
                prev-icon="chevron_left"
                next-icon="chevron_right"
                class="mehvar-pag"
              ></v-pagination>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="chartModal" width="1000">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right">
              <span class="fs-xlarge c-dark">آمار حمایت‌ها</span>
            </v-col>
            <v-col class="text-left">
              <span @click="chartModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <div class="mt-4">
            <Chart
              name="barChart2"
              :chartdata="stateInfo.requestDetails"
              :options="optionsBar2"
              type="bar"
              :height="160"
              v-if="loaded"
            >
            </Chart>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mapInfoModal" width="600">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right">
              <span class="fs-xlarge c-dark">راهنما</span>
            </v-col>
            <v-col class="text-left">
              <span @click="mapInfoModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-card-text>
            <p class="fs-medium c-grey text-justify" style="line-height: 30px">
              برای مشاهده لیست دانشگاه‌ها، شرکت‌ها، محور‌ها و آمار حمایت‌های هر
              استان، استان مورد نظر خود را انتخاب کنید.
            </p>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="catInfoModal" width="600">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right">
              <span class="fs-xlarge c-dark">راهنما</span>
            </v-col>
            <v-col class="text-left">
              <span @click="catInfoModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-card-text>
            <p class="fs-medium c-grey text-justify" style="line-height: 30px">
              برای مشاهده لیست دانشگاه‌ها، شرکت‌ها، محور‌ها و آمار حمایت‌های
              مربوط به هر موضوع، موضوع مورد نظر خود را انتخاب کنید.
            </p>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mehvarInfoModal" width="600">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right">
              <span class="fs-xlarge c-dark">راهنما</span>
            </v-col>
            <v-col class="text-left">
              <span @click="mehvarInfoModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-card-text>
            <p class="fs-medium c-grey text-justify" style="line-height: 30px">
              برای مشاهده لیست دانشگاه‌ها، شرکت‌ها و آمار حمایت‌های مربوط به
              محور مورد نظر، محور مورد نظر خود را جستجو کنید و از لیست محور‌ها،
              محور موردنظر خود را انتخاب کنید و سپس بر روی دکمه جزییات محور‌ها
              کلیک کنید.
            </p>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="companyInfoModal" width="600">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right">
              <span class="fs-xlarge c-dark">راهنما</span>
            </v-col>
            <v-col class="text-left">
              <span @click="companyInfoModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-card-text>
            <p class="fs-medium c-grey text-justify" style="line-height: 30px">
              در این بخش لیستی از شرکت‌های دانش بنیان به همراه موضوع فعالیت و
              محصولات آن‌ها نمایش داده شده است، جهت مشاهده پروفایل شرکت روی سطر
              جدول کلیک کنید.
            </p>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="organizationInfoModal" width="600">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right">
              <span class="fs-xlarge c-dark">راهنما</span>
            </v-col>
            <v-col class="text-left">
              <span @click="organizationInfoModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-card-text>
            <p class="fs-medium c-grey text-justify" style="line-height: 30px">
              در این بخش لیستی از انجمن های دانشگاهی به همراه دانشگاه و دبیر
              آن‌ها نمایش داده شده است.
            </p>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="acceleratorInfoModal" width="600">
      <v-card class="map-modalCard p-2">
        <v-container>
          <v-row>
            <v-col class="text-right">
              <span class="fs-xlarge c-dark">راهنما</span>
            </v-col>
            <v-col class="text-left">
              <span @click="acceleratorInfoModal = false">
                <v-icon class="pointer">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
          <v-card-text>
            <p class="fs-medium c-grey text-justify" style="line-height: 30px">
              در این بخش لیستی از شتاب‌دهنده‌ها به همراه موضوع فعالیت، محورها و
              محصولات آن‌ها نمایش داده شده است، جهت مشاهده پروفایل شتاب‌دهنده
              روی سطر جدول کلیک کنید.
            </p>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="setadMissions" width="600">
      <v-card class="map-modalCard pa-4">
        <v-row>
          <v-col class="text-right"> </v-col>
          <v-col class="text-left">
            <span @click="setadMissions = false">
              <v-icon class="pointer">$Close</v-icon>
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex flex-column justify-content-center align-center">
            <a href="https://isti.ir/" target="_blank">
              <img
                src="../../assets/images/header-right.png"
                style="width: 140px"
              />
            </a>
          </v-col>
          <v-col class="d-flex flex-column justify-content-center align-center">
            <img src="../../assets/images/1403year.png" style="width: 130px" />
          </v-col>
          <v-col class="d-flex justify-content-center flex-column align-center">
            <a href="https://biodc.isti.ir/" target="_blank">
              <img src="../../assets/images/biodc.png" style="width: 140px" />
            </a>
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col class="pt-0 text-center" cols="12">
            <h2 class="c-dark pb-1" style="border-bottom: 2px solid #666">
              ماموریت‌های ستاد
            </h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div v-html="missions"></div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="statesRoles" width="600">
      <v-card class="map-modalCard pa-4">
        <v-row>
          <v-col class="text-right"> </v-col>
          <v-col class="text-left">
            <span @click="statesRoles = false">
              <v-icon class="pointer">$Close</v-icon>
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex flex-column justify-content-center align-center">
            <a href="https://isti.ir/" target="_blank">
              <img
                src="../../assets/images/header-right.png"
                style="width: 140px"
              />
            </a>
          </v-col>
          <v-col class="d-flex flex-column justify-content-center align-center">
            <img src="../../assets/images/1403year.png" style="width: 130px" />
          </v-col>
          <v-col class="d-flex justify-content-center flex-column align-center">
            <a href="https://biodc.isti.ir/" target="_blank">
              <img src="../../assets/images/biodc.png" style="width: 140px" />
            </a>
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col class="pt-2" cols="12">
            <h3
              class="c-dark pb-1 text-center"
              style="border-bottom: 2px solid #666"
            >
              نقش استان‌ها در توسعه زیست فناوری کشور
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div v-html="statesRole"></div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Chart from "/src/components/charts/Chart.vue";
import Flag from "/src/components/Flag.vue";
import { LoopingRhombusesSpinner } from "epic-spinners";
import IranMapVue from "iran-map-vue";
export default {
  components: { IranMapVue, Chart, Flag, LoopingRhombusesSpinner },
  data() {
    return {
      reactivity: false,
      loaded2: false,
      loaded3: false,
      loaded4: false,
      fromProfiles: false,
      // selectedType: "total",
      selectedType: "university",
      deviceType: "",
      mehvarsData: [],
      mehvarsModal: false,
      universitiesModal: false,
      distinguishedUniModal: false,
      researcherModal: false,
      universitiesData: {},
      companiesModal: false,
      companiesData: {},
      organizationsModal: false,
      organizationsData: {},
      acceleratorsModal: false,
      chartModal: false,
      mapInfoModal: false,
      catInfoModal: false,
      mehvarInfoModal: false,
      companyInfoModal: false,
      acceleratorInfoModal: false,
      setadMissions: false,
      statesRoles: false,
      chartData: {},
      filterUni: "",
      filterDistinguished: "",
      filterResearcher: "",
      filterCompany: "",
      filterOrganiation: "",
      filterAccelerator: "",
      filterMehvar: "",
      filterCities: "",
      filterType: "city",
      mehvarFields: [
        { key: "title", label: "محور" },
        { key: "universityname", label: "دانشگاه" },
      ],
      catFields: [
        { key: "name", label: "موضوع" },
        { key: "universityCounts", label: "تعداد" },
      ],
      companiesFields: [
        { key: "name", label: "نام شرکت" },
        { key: "catName", label: "موضوع فعالیت در زیست فناوری" },
        { key: "products", label: "محصولات" },
      ],
      organizationsFields: [
        { key: "name", label: "نام انجمن" },
        { key: "headName", label: "نام دبیر" },
        { key: "university", label: "نام دانشگاه" },
      ],
      acceleratorsFields: [
        { key: "name", label: "نام شتاب‌دهنده" },
        { key: "catName", label: "موضوع فعالیت در زیست فناوری" },
        { key: "products", label: "محصولات" },
      ],
      mehvarTabFields: [
        { key: "selected", label: "" },
        { key: "name", label: "محور" },
        { key: "catName", label: "موضوع" },
        { key: "universityName", label: "دانشگاه" },
      ],
      mehvars: [],
      mehvarIds: [],
      chosenMehvars: [],
      accelerators: [],
      allAccelerators: [],
      selectedCity: {
        key: null,
      },
      stateInfo: [],
      tab: null,
      titlesFilter: "",
      citiesFilter: "",
      companiesFilter: "",
      acceleratorsFilter: "",
      mehvarsFilter: "",
      currentPage: 1,
      companiesCurrentPage: 1,
      oldCurrentPage: 1,
      oldCompaniesCurrentPage: 1,
      acceleratorsCurrentPage: 1,
      oldAcceleratorsCurrentPage: 1,
      mehvarTabCurrentPage: 1,
      oldmehvarTabCurrentPage: 1,
      totalRows: "",
      companiesTotalRows: "",
      acceleratorsTotalRows: "",
      mehvarTabTotalRows: "",
      perPage: 10,
      companiesPerPage: 10,
      acceleratorsPerPage: 10,
      mehvarTabPerPage: 10,
      oldPerPage: 10,
      oldCompaniesPerPage: 10,
      oldAcceleratorsPerPage: 10,
      mehvarsCurrentPage: 1,
      mehvarsPerPage: 4,
      mehvarTotalRows: "",
      selectedTitle: [],
      perPageOptions: ["10", "25", "50", "100"],
      sidebar: false,
      hoveredCity: "",
      busy: true,
      tableBusy: false,
      companiesTableBusy: false,
      acceleratorsTableBusy: false,
      mehvarTabBusy: false,
      loaded: false,
      companies: [],
      organizations: [],
      organizationsTotalRows: 0,
      organizationsFilter: "",
      organizationsCurrentPage: 1,
      oldOrganizationsCurrentPage: 1,
      organizationsPerPage: 10,
      oldOrganizationsPerPage: 10,
      organizationsTableBusy: false,
      organizationInfoModal: false,
      cats: [],
      iran: [],
      statesRole: "",
      missions: "",
      optionsBar: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: true,
            position: "right",
            labels: {
              font: {
                family: "iransans",
              },
              boxWidth: 24,
              boxHeight: 24,
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            scaleLabel: {
              display: true,
              labelString: "",
            },
            min: 0,
            ticks: {
              stepSize: 10,
              beginAtZero: true,
              font: { family: "iransans" },
            },
          },
          x: {
            ticks: {
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      optionsBar2: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: true,
            position: "right",
            labels: {
              font: {
                family: "iransans",
              },
              boxWidth: 24,
              boxHeight: 24,
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            scaleLabel: {
              display: true,
              labelString: "",
            },
            min: 0,
            ticks: {
              stepSize: 4,
              beginAtZero: true,
              font: { family: "iransans" },
            },
            stacked: true,
          },
          x: {
            stacked: true,
            ticks: {
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      selectedState: "",
      cityColors: {},
      cities: [
        { text: "البرز", value: "Alborz" },
        { text: "اردبیل", value: "Ardabil" },
        { text: "آذربایجان شرقی", value: "AzerbaijanEast" },
        { text: "آذربایجان غربی", value: "AzerbaijanWest" },
        { text: "بوشهر", value: "Bushehr" },
        { text: "چهارمحال وبختیاری", value: "ChaharMahaalBakhtiari" },
        { text: "فارس", value: "Fars" },
        { text: "گیلان", value: "Gilan" },
        { text: "گلستان", value: "Golestan" },
        { text: "همدان", value: "Hamadan" },
        { text: "هرمزگان", value: "Hormozgan" },
        { text: "ایلام", value: "Ilam" },
        { text: "اصفهان", value: "Isfahan" },
        { text: "کرمان", value: "Kerman" },
        { text: "کرمانشاه", value: "Kermanshah" },
        { text: "خراسان شمالی", value: "KhorasanNorth" },
        { text: "خراسان رضوی", value: "KhorasanRazavi" },
        { text: "خراسان جنوبی", value: "KhorasanSouth" },
        { text: "خوزستان", value: "Khuzestan" },
        { text: "کهگیلویه وبویراحمد", value: "KohgiluyehBoyerAhmad" },
        { text: "کردستان", value: "Kurdistan" },
        { text: "لرستان", value: "Lorestan" },
        { text: "مرکزی", value: "Markazi" },
        { text: "مازندران", value: "Mazandaran" },
        { text: "قزوین", value: "Qazvin" },
        { text: "قم", value: "Qom" },
        { text: "سمنان", value: "Semnan" },
        { text: "سیستان وبلوچستان", value: "SistanBaluchestan" },
        { text: "تهران", value: "Tehran" },
        { text: "یزد", value: "Yazd" },
        { text: "زنجان", value: "Zanjan" },
      ],
      obj: [
        { arb: "ك", per: "ک" },
        { arb: "دِ", per: "د" },
        { arb: "بِ", per: "ب" },
        { arb: "زِ", per: "ز" },
        { arb: "ذِ", per: "ذ" },
        { arb: "شِ", per: "ش" },
        { arb: "سِ", per: "س" },
        { arb: "ى", per: "ی" },
        { arb: "ي", per: "ی" },
      ],
      provincesArray: [
        {
          id: "6315a603fd303cbe07ced4e3",
          name: "AzerbaijanEast",
        },
        {
          id: "6315a603fd303cbe07ced4e4",
          name: "AzerbaijanWest",
        },
        {
          id: "6315a603fd303cbe07ced4e5",
          name: "Ardabil",
        },
        {
          id: "6315a603fd303cbe07ced4e6",
          name: "Isfahan",
        },
        {
          id: "6315a603fd303cbe07ced4e7",
          name: "Alborz",
        },
        {
          id: "6315a603fd303cbe07ced4e8",
          name: "Ilam",
        },
        {
          id: "6315a603fd303cbe07ced4e9",
          name: "Bushehr",
        },
        {
          id: "6315a603fd303cbe07ced4ea",
          name: "Tehran",
        },
        {
          id: "6315a603fd303cbe07ced4eb",
          name: "ChaharMahaalBakhtiari",
        },
        {
          id: "6315a603fd303cbe07ced4ec",
          name: "KhorasanSouth",
        },
        {
          id: "6315a603fd303cbe07ced4ed",
          name: "KhorasanRazavi",
        },
        {
          id: "6315a603fd303cbe07ced4ee",
          name: "KhorasanNorth",
        },
        {
          id: "6315a603fd303cbe07ced4ef",
          name: "Khuzestan",
        },
        {
          id: "6315a603fd303cbe07ced4f0",
          name: "Zanjan",
        },
        {
          id: "6315a603fd303cbe07ced4f1",
          name: "Semnan",
        },
        {
          id: "6315a603fd303cbe07ced4f2",
          name: "SistanBaluchestan",
        },
        {
          id: "6315a603fd303cbe07ced4f3",
          name: "Fars",
        },
        {
          id: "6315a603fd303cbe07ced4f4",
          name: "Qazvin",
        },
        {
          id: "6315a603fd303cbe07ced4f5",
          name: "Qom",
        },
        {
          id: "6315a603fd303cbe07ced4f6",
          name: "Kurdistan",
        },
        {
          id: "6315a603fd303cbe07ced4f7",
          name: "Kerman",
        },
        {
          id: "6315a603fd303cbe07ced4f8",
          name: "Kermanshah",
        },
        {
          id: "6315a603fd303cbe07ced4f9",
          name: "KohgiluyehBoyerAhmad",
        },
        {
          id: "6315a603fd303cbe07ced4fa",
          name: "Golestan",
        },
        {
          id: "6315a603fd303cbe07ced4fb",
          name: "Gilan",
        },
        {
          id: "6315a603fd303cbe07ced4fc",
          name: "Lorestan",
        },
        {
          id: "6315a603fd303cbe07ced4fd",
          name: "Mazandaran",
        },
        {
          id: "6315a603fd303cbe07ced4fe",
          name: "Markazi",
        },
        {
          id: "6315a603fd303cbe07ced4ff",
          name: "Hormozgan",
        },
        {
          id: "6315a603fd303cbe07ced500",
          name: "Hamadan",
        },
        {
          id: "6315a603fd303cbe07ced501",
          name: "Yazd",
        },
      ],
      provinces: {},
      mapLoaded: false,
      transition: false,
      isMap: false,
      allStates: [],
      checkbox: [],
      selectedMehvars: [],
      selectAll: false,
      selectedRows: [],
      showInfo: true,
      largeScreen: false,
      selectedCategory: { name: "", id: "" },
      fromResearcher: false,
      chosenCategory: {},
      catsLoading: false,
      chooseMehvarDialog: false,
      role: window.localStorage.role,
      mapStats: [
        { title: "تعداد دانشگاه‌ها و مراکز پژوهشی فعال", value: 0 },
        // { title: "تعداد دانشگاه‌ها و مراکز پژوهشی نیازمند اصلاح", value: 0 },
        { title: "تعداد کلان پروژه‌ها", value: 0 },
        { title: "تعداد خرده پروژه‌ها", value: 0 },
        { title: "تعداد تفاهم‌نامه‌ها", value: 0 },
      ],
    };
  },
  methods: {
    calCurrent() {
      this.currentPage = Math.ceil(
        (this.oldPerPage * (this.oldCurrentPage - 1) + 1) / this.perPage
      );
      this.oldPerPage = this.perPage;
      this.oldCurrentPage = this.currentPage;
    },
    calCompaniesCurrent() {
      this.companiesCurrentPage = Math.ceil(
        (this.oldCompaniesPerPage * (this.oldCompaniesCurrentPage - 1) + 1) /
          this.companiesPerPage
      );
      this.oldCompaniesPerPage = this.companiesPerPage;
      this.oldCompaniesCurrentPage = this.companiesCurrentPage;
    },
    calOrganizationsCurrent() {
      this.organizationsCurrentPage = Math.ceil(
        (this.oldOrganizationsPerPage * (this.oldOrganizationsCurrentPage - 1) +
          1) /
          this.organizationsPerPage
      );
      this.oldOrganizationsPerPage = this.organizationsPerPage;
      this.oldOrganizationsCurrentPage = this.organizationsCurrentPage;
    },
    calAcceleratorsCurrent() {
      this.acceleratorsCurrentPage = Math.ceil(
        (this.oldAcceleratorsPerPage * (this.oldAcceleratorsCurrentPage - 1) +
          1) /
          this.acceleratorsPerPage
      );
      this.oldAcceleratorsPerPage = this.acceleratorsPerPage;
      this.oldAcceleratorsCurrentPage = this.acceleratorsCurrentPage;
    },
    openModal(type) {
      if (type == "uni") {
        this.universitiesModal = true;
      } else if (type == "company") {
        this.companiesModal = true;
      } else if (type == "organization") {
        this.organizationsModal = true;
      } else if (type == "accelerator") {
        this.acceleratorsModal = true;
      } else if (type == "mehvar") {
        this.filterMehvar = "";
        this.mehvarsCurrentPage = 1;
        this.mehvarsModal = true;
      } else if (type == "chart") {
        this.chartModal = true;
      } else if (type == "researcher") {
        this.researcherModal = true;
      } else if (type == "distinguishedUni") {
        this.distinguishedUniModal = true;
      }
    },
    hoverMap(item) {
      this.hoveredCity = item;
    },
    onRowSelected(item) {
      if (!item) {
        return;
      }
      this.fromProfiles = false;
      document.querySelector(".v-navigation-drawer__content").scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      this.selectedTitle = [];
      this.selectedTitle[0] = item;
      this.selectedTitle.length
        ? (this.sidebar = true)
        : (this.sidebar = false);
      this.busy = true;
      this.loaded = false;
      this.loaded2 = false;
      this.loaded3 = false;
      this.loaded4 = false;

      this.$http
        .post(this.baseUrl + "/setad/public/categories/getInfo", {
          catId: item.id,
        })
        .then((res) => {
          this.stateInfo = res.data;
          this.mehvarTotalRows = this.stateInfo.mehvarsCount;
          this.loaded2 = true;
          this.loaded3 = true;
          this.loaded4 = true;
          if (window.screen.width < 450 || document.body.clientWidth < 450) {
            this.optionsBar.plugins.legend.labels.font.size = "8";
            this.optionsBar.scales.x.ticks.font.size = "8";
            this.optionsBar.scales.y.ticks.font.size = "8";
          }
          this.optionsBar.scales.y.ticks.stepSize =
            this.stateInfo.shortRequestsStep;
          this.optionsBar2.scales.y.ticks.stepSize =
            this.stateInfo.requestDetailsStepSum;
          setTimeout(() => {
            this.loaded = true;
          }, 500);
          this.busy = false;
          this.fromResearcher = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    getMehvarsReport() {
      this.fromProfiles = false;
      document.querySelector(".v-navigation-drawer__content").scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      this.selectedTitle = "گزارش محور‌ها";
      this.selectedTitle.length
        ? (this.sidebar = true)
        : (this.sidebar = false);
      this.busy = true;
      this.loaded = false;
      this.loaded2 = false;
      this.loaded3 = false;
      this.loaded4 = false;

      this.$http
        .post(this.baseUrl + "/setad/public/mehvars/getInfo", {
          mehvarIds: this.mehvarIds,
        })
        .then((res) => {
          this.stateInfo = res.data;
          this.mehvarTotalRows = this.stateInfo.mehvarsCount;

          this.loaded2 = true;
          this.loaded3 = true;
          this.loaded4 = true;
          if (window.screen.width < 450 || document.body.clientWidth < 450) {
            this.optionsBar.plugins.legend.labels.font.size = "8";
            this.optionsBar.scales.x.ticks.font.size = "8";
            this.optionsBar.scales.y.ticks.font.size = "8";
          }
          this.optionsBar.scales.y.ticks.stepSize =
            this.stateInfo.shortRequestsStep;
          this.optionsBar2.scales.y.ticks.stepSize =
            this.stateInfo.requestDetailsStepSum;
          setTimeout(() => {
            this.loaded = true;
          }, 500);
          this.busy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    companyOnRowSelected(item) {
      if (!item[0]) {
        return;
      }
      let companyLink = "companyProfile/" + item[0].id;
      window.open(companyLink, "_blank");
    },
    acceleratorOnRowSelected(item) {
      if (!item[0]) {
        return;
      }
      let acceleratorLink = "acceleratorProfile/" + item[0].id;
      window.open(acceleratorLink, "_blank");
    },
    chooseCategory(item) {
      if (this.chosenCategory && this.chosenCategory.id == item.id) {
        this.chosenCategory = {};
        this.sidebar = false;
      } else {
        this.chosenCategory = item;
        this.onRowSelected(item);
      }
    },
    chooseMehvar(item) {
      if (
        this.selectedMehvars.length &&
        this.selectedMehvars.includes(item.name)
      ) {
        let index;
        index = this.selectedMehvars.indexOf(item.name);
        this.selectedMehvars.splice(index, 1);
        this.mehvarIds.splice(index, 1);
      } else {
        this.selectedMehvars.push(item.name);
        this.mehvarIds.push(item.id);
      }
    },
    selectMehvarFunc(item) {
      this.selectedMehvars.includes(item.name)
        ? this.chooseMehvar(item)
        : !this.checkMehvarCount
        ? this.chooseMehvar(item)
        : (this.chooseMehvarDialog = true);
      this.sidebar ? (this.sidebar = false) : "";
    },
    selectAllMehvars() {
      this.computedMehvars2.forEach((x) => {
        if (!this.selectedMehvars.includes(x.name)) {
          this.selectedMehvars.push(x.name);
          this.mehvarIds.push(x.id);
        }
      });
    },
    clearAllMehvars() {
      this.selectedMehvars = [];
      this.mehvarIds = [];
      this.selectAll = false;
      this.sidebar ? (this.sidebar = false) : "";
    },
    clearSelect() {
      this.$refs.mytable.clearSelected();
    },
    goTo() {
      if (this.role) {
        this.$router.push("/" + this.role + "/dashboard");
      } else {
        this.$router.push("/login");
      }
    },
    mapLeave() {
      if (this.fromProfiles) {
        let state = this.cities.filter((x) => x.text == this.selectedState)[0]
          .value;
        // this.provincesArray.forEach((city) => {
        //   if (state != city.name) {
        //     this.provinces[city.name].bgColor = "#ffffff";
        //     this.provinces[city.name].stroke = "#ffffff";
        //     this.provinces[city.name].strokeWidth = "0px";
        //   } else {
        //     this.provinces[city.name].bgColor =
        //       this.cityColors[city.name].stroke;
        //     this.provinces[city.name].stroke =
        //       this.cityColors[city.name].stroke;
        //     this.provinces[city.name].strokeWidth = "2px";
        //   }
        // });
      } else {
        // this.provincesArray.forEach((city) => {
        //   if (this.selectedCity.key != city.name) {
        //     this.provinces[city.name].bgColor = "#ffffff";
        //     this.provinces[city.name].stroke = "#ffffff";
        //     this.provinces[city.name].strokeWidth = "0px";
        //   } else {
        //     this.provinces[city.name].bgColor =
        //       this.cityColors[city.name].stroke;
        //     this.provinces[city.name].stroke =
        //       this.cityColors[city.name].stroke;
        //     this.provinces[city.name].strokeWidth = "2px";
        //   }
        // });
      }
    },
    _clickMap(item) {
      setTimeout(() => {
        if (this.busy) {
          const title = (
            <div>
              <h5 class="text-center">...کندی سرعت اینترنت</h5>
              <span>
                به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
                اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
              </span>
            </div>
          );
          this.toast(title, "warning");
          this.$bvModal.hide("loading");
        }
      }, this.isLoadedTimeOut);
      this.fromProfiles = false;
      let wasOpened;
      !this.sidebar ? (wasOpened = false) : (wasOpened = true);
      !wasOpened ? (this.transition = false) : "";
      document.querySelector(".v-navigation-drawer__content").scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      if (item.type == "province") {
        this.selectedCity = item;
        this.provincesArray.forEach((city) => {
          if (this.selectedCity.key != city.name) {
            this.provinces[city.name].bgColor = "#ffffff";
            this.provinces[city.name].stroke = "#ffffff";
            this.provinces[city.name].strokeWidth = "0px";
          } else {
            this.provinces[city.name].bgColor = "#17b075";
            this.provinces[city.name].stroke = "#17b075";
            this.provinces[city.name].strokeWidth = "2px";
          }
        });
        setTimeout(() => {
          this.sidebar = true;
          !wasOpened ? (this.mapLoaded = false) : "";
        }, 50);

        this.busy = true;
        this.loaded = false;
        this.loaded2 = false;
        this.loaded3 = false;
        this.loaded4 = false;
        this.$http
          .post(this.baseUrl + "/setad/public/states/getInfo", {
            stateId: this.iran.filter(
              (x) => x.name == this.selectedCity.mapData.name
            )[0].id,
          })
          .then((res) => {
            this.stateInfo = res.data;
            this.mehvarTotalRows = this.stateInfo.mehvarsCount;
            this.loaded2 = true;
            this.loaded3 = true;
            this.loaded4 = true;

            if (window.screen.width < 450 || document.body.clientWidth < 450) {
              this.optionsBar.plugins.legend.labels.font.size = "8";
              this.optionsBar.scales.x.ticks.font.size = "8";
              this.optionsBar.scales.y.ticks.font.size = "8";
            }
            this.optionsBar.scales.y.ticks.stepSize =
              this.stateInfo.shortRequestsStep;
            this.optionsBar2.scales.y.ticks.stepSize =
              this.stateInfo.requestDetailsStepSum;
            setTimeout(() => {
              this.loaded = true;
              !wasOpened ? (this.transition = true) : "";
              !wasOpened ? (this.mapLoaded = true) : "";
            }, 100);
            this.busy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.busy = false;
          });
      }
    },
    closeSidebar() {
      this.transition = false;

      setTimeout(() => {
        this.mapLoade = false;
      }, 200);

      this.provincesArray.forEach((city) => {
        this.provinces[city.name].bgColor = this.cityColors[city.name].bgColor;
        this.provinces[city.name].stroke = this.cityColors[city.name].stroke;
        this.provinces[city.name].strokeWidth = "2px";
      });
      setTimeout(() => {
        this.sidebar = false;
        this.chosenCategory = {};
        this.showInfo = true;
        this.mapLoade = true;
        this.transition = true;
        this.selectedCity = { key: null };
      }, 500);
    },
    getCats() {
      //this.catsLoading = true;
      //this.cats = [
      //  {
      //    id: "1",
      //    name: "موضوع تستی ۱",
      //    universityCounts: 4,
      //  },
      //  {
      //    id: "2",
      //    name: "موضوع تستی 2",
      //    universityCounts: 5,
      //  },
      //  {
      //    id: "2",
      //    name: "موضوع تستی 2",
      //    universityCounts: 5,
      //  },
      //  {
      //    id: "4",
      //    name: "موضوع تستی 2",
      //    universityCounts: 5,
      //  },
      //  {
      //    id: "2",
      //    name: "موضوع تستی 2",
      //    universityCounts: 5,
      //  },
      //  {
      //    id: "2",
      //    name: "موضوع تستی 2",
      //    universityCounts: 5,
      //  },
      //  {
      //    id: "2",
      //    name: "موضوع تستی 2",
      //    universityCounts: 5,
      //  },
      //  {
      //    id: "2",
      //    name: "موضوع تستی 2",
      //    universityCounts: 5,
      //  },
      //  {
      //    id: "2",
      //    name: "موضوع تستی 2",
      //    universityCounts: 5,
      //  },
      //  {
      //    id: "9",
      //    name: "موضوع تستی 2",
      //    universityCounts: 5,
      //  },
      //  {
      //    id: "11",
      //    name: "آرینا ۱۱",
      //    universityCounts: 5,
      //  },
      //  {
      //    id: "12",
      //    name: "معین 12",
      //    universityCounts: 5,
      //  },
      //];
      //this.totalRows = this.cats.length;
      //this.catsLoading = false;
      //this.tableBusy = true;
      //this.$http
      //  .post(this.baseUrl + "/setad/public/categories/getAll", {})
      //  .then((res) => {
      //    this.cats = res.data;
      //    this.totalRows = this.cats.length;
      //    this.tableBusy = false;
      //  })
      //  .catch((err) => {
      //    console.log(err);
      //    this.toast(err.response.data, "error");
      //    this.tableBusy = false;
      //  });
    },
    getCompanies() {
      this.companiesTableBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/public/company/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem(""),
            },
          }
        )
        .then((res) => {
          this.companies = res.data;
          this.companiesTotalRows = this.companies.length;
          this.companiesTableBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.companiesTableBusy = false;
        });
    },
    getAccelerators() {
      this.acceleratorsTableBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/public/accelerator/getAll",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem(""),
            },
          }
        )
        .then((res) => {
          this.allAccelerators = res.data;
          this.acceleratorsTotalRows = this.allAccelerators.length;
          this.acceleratorsTableBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.acceleratorsTableBusy = false;
        });
    },
    getMehvars() {
      this.mehvarTabBusy = true;
      this.$http
        .get(this.baseUrl + "/setad/public/mehvars/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.mehvars = res.data;
          this.mehvarTabTotalRows = this.mehvars.length;
          for (let i = 0; i < res.data.length; i++) {
            this.checkbox.push(false);
          }
          this.mehvarTabBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.mehvarTabBusy = false;
        });
    },
    mehvarOnFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.mehvarTotalRows = filteredItems.length;
      this.mehvarsCurrentPage = 1;
    },
    selectState() {
      setTimeout(() => {
        if (this.busy) {
          const title = (
            <div>
              <h5 class="text-center">...کندی سرعت اینترنت</h5>
              <span>
                به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
                اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
              </span>
            </div>
          );
          this.toast(title, "warning");
          this.$bvModal.hide("loading");
        }
      }, this.isLoadedTimeOut);
      this.fromProfiles = true;
      this.selectedState = localStorage.getItem("state");
      let state = this.cities.filter(
        (x) => x.text == localStorage.getItem("state")
      )[0].value;
      this.sidebar = true;
      this.busy = true;
      this.provincesArray.forEach((city) => {
        if (state != city.name) {
          this.provinces[city.name].bgColor = "#ffffff";
          this.provinces[city.name].stroke = "#ffffff";
          this.provinces[city.name].strokeWidth = "0px";
        } else {
          this.provinces[city.name].bgColor = "#17b075";
          this.provinces[city.name].stroke = "#17b075";
          this.provinces[city.name].strokeWidth = "2px";
        }
      });
      this.$http
        .post(this.baseUrl + "/setad/public/states/getInfo", {
          stateId: localStorage.getItem("stateId"),
        })
        .then((res) => {
          this.stateInfo = res.data;
          this.mehvarTotalRows = this.stateInfo.mehvarsCount;
          this.loaded2 = true;
          this.loaded3 = true;
          this.loaded4 = true;

          if (window.screen.width < 450 || document.body.clientWidth < 450) {
            this.optionsBar.plugins.legend.labels.font.size = "8";
            this.optionsBar.scales.x.ticks.font.size = "8";
            this.optionsBar.scales.y.ticks.font.size = "8";
          }
          this.optionsBar.scales.y.ticks.stepSize =
            this.stateInfo.shortRequestsStep;
          this.optionsBar2.scales.y.ticks.stepSize =
            this.stateInfo.requestDetailsStepSum;
          setTimeout(() => {
            this.loaded = true;
          }, 500);
          this.busy = false;
          if (localStorage.getItem("item")) {
            if (
              localStorage.getItem("item") == "university" &&
              this.stateInfo.universitiesCount > 3
            ) {
              this.openModal("uni");
            } else if (
              localStorage.getItem("item") == "company" &&
              this.stateInfo.companiesCount > 3
            ) {
              this.openModal("company");
            } else if (
              localStorage.getItem("item") == "organization" &&
              this.stateInfo.organizationsCount > 3
            ) {
              this.openModal("organization");
            } else if (
              localStorage.getItem("item") == "accelerator" &&
              this.stateInfo.acceleratorsCount > 3
            ) {
              this.openModal("accelerator");
            } else if (
              localStorage.getItem("item") == "researcher" &&
              this.stateInfo.researchers &&
              this.stateInfo.researchersCount > 3
            ) {
              this.openModal("researcher");
            } else if (
              localStorage.getItem("item") == "disUni" &&
              this.stateInfo.distinguishedUniversitiesCount > 3
            ) {
              this.openModal("distinguishedUni");
            }
          }
          localStorage.removeItem("state");
          localStorage.removeItem("item");
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.busy = false;
        });
    },
    getData() {
      if (localStorage.getItem("catId")) {
        this.catsLoading = true;
        this.selectedCategory.id = localStorage.getItem("catId");
        this.selectedCategory.name = localStorage.getItem("catName");
        this.chosenCategory = this.selectedCategory;
        this.tab = 1;
        localStorage.removeItem("catId");
        localStorage.removeItem("catName");
        this.filterType = "title";
      }
      this.transition = false;
      setTimeout(() => {
        this.mapLoaded = false;
      }, 450);
      this.$http
        .get(
          this.baseUrl + "/setad/public/states/map?type=" + this.selectedType,
          {}
        )
        .then((res) => {
          this.cats = res.data.categories;
          this.totalRows = this.cats.length;
          this.companies = res.data.companies;
          this.companiesTotalRows = this.companies.length;
          this.organizations = res.data.organizations;
          this.organizationsTotalRows = this.organizations.length;
          this.allAccelerators = res.data.accelerators;
          this.acceleratorsTotalRows = this.allAccelerators.length;
          this.mehvars = res.data.mehvars;
          this.mehvarTabTotalRows = this.mehvars.length;
          this.pageLoading = false;
          if (this.chosenCategory.id) {
            this.catsLoading = false;
            this.selectCategory();
          }
          this.iran = res.data.states;

          if (res.data.options) {
            this.statesRole = res.data.options.filter(
              (x) => x.key == "statesRole"
            )[0]
              ? res.data.options.filter((x) => x.key == "statesRole")[0].value
              : "";
            this.missions = res.data.options.filter(
              (x) => x.key == "missions"
            )[0]
              ? res.data.options.filter((x) => x.key == "missions")[0].value
              : "";
          }

          this.iran.forEach((element) => {
            if (this.provincesArray.filter((x) => x.id == element.id)[0]) {
              element.enName = this.provincesArray.filter(
                (x) => x.id == element.id
              )[0].name;
            }
          });

          let basicColor;
          let title;
          // if (this.selectedType == "total") {
          //   basicColor = "6, 141, 157";
          //   title = "درخواست‌های ثبت شده";
          // } else if (this.selectedType == "accepted ") {
          //   basicColor = "183, 28, 28";
          //   title = "حمایت‌های تایید شده";
          // } else
          if (this.selectedType == "company") {
            basicColor = "3, 73, 105";
            // basicColor = "124, 53, 177";
            title = "شرکت‌های دانش بنیان";
          } else if (this.selectedType == "university") {
            basicColor = "124, 53, 177";
            // basicColor = "3, 73, 105";
            title = "دانشگاه‌ها";
          } else if (this.selectedType == "mehvar") {
            basicColor = "27, 94, 32";
            title = "محورها";
          }

          this.iran.forEach((element2) => {
            if (element2.enName) {
              this.provinces[element2.enName] = {
                name: element2.name,
                color: "#000",
                stroke:
                  "rgba(" + basicColor + "," + Number(element2.alpha) + ")",
                strokeWidth: "0px",
                bgColor:
                  "rgba(" + basicColor + "," + Number(element2.alpha) + ")",
                opacity: 1,
                bubbleColor: "#f00",
                content: "<span>" + element2.name + "</span>",
                tooltip:
                  "<span class='name'>" +
                  this.iran.filter((x) => x.name == element2.name)[0].name +
                  "</span><br><div class='requestCount'>" +
                  title +
                  ": " +
                  this.iran.filter((x) => x.name == element2.name)[0].count +
                  "</div>",
              };
            }
          });

          this.iran.forEach((element3) => {
            if (element3.enName) {
              this.cityColors[element3.enName] = {
                stroke:
                  "rgba(" + basicColor + "," + Number(element3.alpha) + ")",
                bgColor:
                  "rgba(" + basicColor + "," + Number(element3.alpha) + ")",
              };
            }
          });
          setTimeout(() => {
            this.transition = true;
            this.mapLoaded = true;
            //mapInfo Modal management
            if (!localStorage.getItem("mapInfoDialog")) {
              this.mapInfoModal = true;
              localStorage.setItem("mapInfoDialog", true);
            }
            //state management
            if (localStorage.getItem("state")) {
              this.selectState();
              this.filterType == "city";
            }
            //company and accelerator list management
            if (localStorage.getItem("list")) {
              let listType = localStorage.getItem("list");
              if (listType == "company") {
                this.tab = 4;
                this.filterType = "companies";
              } else if (listType == "organization") {
                this.tab = 5;
                this.filterType = "organizations";
              }
              // else if (listType == "accelerator") {
              //   this.tab = 3;
              //   this.filterType = "accelerators";
              // }
            }
            localStorage.removeItem("list");
          }, 500);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getDashboardData() {
      this.$http
        .get(this.baseUrl + "/setad/public/dashboard/", {})
        .then((res) => {
          const data = res.data;
          this.mapStats = [
            {
              title: "تعداد دانشگاه‌ها و مراکز پژوهشی فعال",
              value: data.universities ? data.universities : 0,
            },
            // {
            //   title: "تعداد دانشگاه‌ها و مراکز پژوهشی نیازمند اصلاح",
            //   value: data.editUniversities ? data.editUniversities : 0,
            // },
            {
              title: "تعداد کلان پروژه‌ها",
              value: data.projects ? data.projects : 0,
            },
            {
              title: "تعداد خرده پروژه‌ها",
              value: data.subProjects ? data.subProjects : 0,
            },
            {
              title: "تعداد تفاهم‌نامه‌ها",
              value: data.finalProjects ? data.finalProjects : 0,
            },
          ];
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    selectCategory() {
      if (!this.catsLoading) {
        this.cats.forEach((item, index) => {
          if (item.id == this.chosenCategory.id) {
            if ((index + 1) % this.perPage != 0) {
              this.currentPage = Math.floor((index + 1) / this.perPage + 1);
            } else {
              this.currentPage = (index + 1) / this.perPage;
            }
          }
        });
        console.log(this.chosenCategory);
        this.onRowSelected(this.chosenCategory);
      }
    },
  },
  watch: {
    hoveredCity(val) {
      if (val.type == "province") {
        // this.provincesArray.forEach((city) => {
        //   if (this.provinces[city.name].content == val.mapData.content) {
        //     this.provinces[city.name].bgColor =
        //       this.cityColors[city.name].bgColor;
        //     this.provinces[city.name].stroke =
        //       this.cityColors[city.name].stroke;
        //     this.provinces[city.name].strokeWidth = "2px";
        //   } else {
        //     if (this.fromProfiles) {
        //       let state = this.cities.filter(
        //         (x) => x.text == this.selectedState
        //       )[0].value;
        //       this.provincesArray.forEach((city) => {
        //         if (state != city.name) {
        //           this.provinces[city.name].bgColor = "#ffffff";
        //           this.provinces[city.name].stroke = "#ffffff";
        //           this.provinces[city.name].strokeWidth = "0px";
        //         } else {
        //           this.provinces[city.name].bgColor =
        //             this.cityColors[city.name].stroke;
        //           this.provinces[city.name].stroke =
        //             this.cityColors[city.name].stroke;
        //           this.provinces[city.name].strokeWidth = "2px";
        //         }
        //       });
        //     } else {
        //       if (this.selectedCity.key != city.name) {
        //         this.provinces[city.name].bgColor = "#ffffff";
        //         this.provinces[city.name].stroke = "#ffffff";
        //         this.provinces[city.name].strokeWidth = "0px";
        //       } else {
        //         this.provinces[city.name].bgColor =
        //           this.cityColors[city.name].stroke;
        //         this.provinces[city.name].stroke =
        //           this.cityColors[city.name].stroke;
        //         this.provinces[city.name].strokeWidth = "2px";
        //       }
        //     }
        //   }
        // });
      }
    },
  },
  computed: {
    showTabs() {
      if (this.deviceType == "mobile") {
        if (this.sidebar) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    uniFilteredList() {
      let filtered;
      if (this.stateInfo.universities) {
        filtered = this.stateInfo.universities.filter((x) =>
          x.name.includes(this.filterUni)
        );
        return filtered;
      } else {
        filtered = [];
      }
    },
    distinguishedFilteredList() {
      let filtered;
      if (this.stateInfo.distinguishedUniversities) {
        filtered = this.stateInfo.distinguishedUniversities.filter((x) =>
          x.name.includes(this.filterDistinguished)
        );
        return filtered;
      } else {
        filtered = [];
      }
    },
    researcherFilteredList() {
      let filtered;
      if (this.stateInfo.researchers && this.stateInfo.researchersCount) {
        filtered = this.stateInfo.researchers.filter((x) =>
          x.name.includes(this.filterResearcher)
        );
        return filtered;
      } else {
        filtered = [];
        return filtered;
      }
    },
    companyFilteredList() {
      let filtered;
      if (this.stateInfo.companies) {
        filtered = this.stateInfo.companies.filter((x) =>
          x.name.includes(this.filterCompany)
        );
        return filtered;
      } else {
        filtered = [];
      }
    },
    organizationFilteredList() {
      let filtered;
      if (this.stateInfo.organizations) {
        filtered = this.stateInfo.organizations.filter((x) =>
          x.name.includes(this.filterOrganiation)
        );
        return filtered;
      } else {
        filtered = [];
      }
    },
    acceleratorFilteredList() {
      let filtered;
      if (this.stateInfo.accelerators) {
        filtered = this.stateInfo.accelerators.filter((x) =>
          x.name.includes(this.filterAccelerator)
        );
        return filtered;
      } else {
        filtered = [];
      }
    },
    computedCats() {
      let filtered = [];
      this.obj.forEach((char) => {
        if (this.titlesFilter.includes(char.arb)) {
          this.titlesFilter = this.titlesFilter.replace(char.arb, char.per);
        }
      });

      filtered = this.cats.filter((x) => x.name.includes(this.titlesFilter));
      filtered = filtered.slice(
        this.perPage * (this.currentPage - 1),
        this.perPage * this.currentPage
      );
      return filtered;
    },
    computedAccelerators() {
      let filtered = [];
      this.obj.forEach((char) => {
        if (this.acceleratorsFilter.includes(char.arb)) {
          this.acceleratorsFilter = this.acceleratorsFilter.replace(
            char.arb,
            char.per
          );
        }
      });

      filtered = this.allAccelerators.filter((x) =>
        x.name.includes(this.acceleratorsFilter)
      );
      return filtered;
    },
    computedCompanies() {
      let filtered = [];
      this.obj.forEach((char) => {
        if (this.companiesFilter.includes(char.arb)) {
          this.companiesFilter = this.companiesFilter.replace(
            char.arb,
            char.per
          );
        }
      });

      filtered = this.companies.filter((x) =>
        x.name.includes(this.companiesFilter)
      );
      return filtered;
    },
    computedOrganizations() {
      let filtered = [];
      this.obj.forEach((char) => {
        if (this.companiesFilter.includes(char.arb)) {
          this.companiesFilter = this.companiesFilter.replace(
            char.arb,
            char.per
          );
        }
      });

      filtered = this.companies.filter((x) =>
        x.name.includes(this.companiesFilter)
      );
      return filtered;
    },
    computedOrganizations() {
      let filtered = [];
      this.obj.forEach((char) => {
        if (this.organizationsFilter.includes(char.arb)) {
          this.organizationsFilter = this.organizationsFilter.replace(
            char.arb,
            char.per
          );
        }
      });

      filtered = this.organizations.filter((x) =>
        x.name.includes(this.organizationsFilter)
      );
      return filtered;
    },
    computedMehvars() {
      let filtered = [];
      this.obj.forEach((char) => {
        if (this.mehvarsFilter.includes(char.arb)) {
          this.mehvarsFilter = this.mehvarsFilter.replace(char.arb, char.per);
        }
      });

      filtered = this.mehvars.filter((x) =>
        x.name.includes(this.mehvarsFilter)
      );
      filtered = filtered.slice(
        this.mehvarTabPerPage * (this.mehvarTabCurrentPage - 1),
        this.mehvarTabPerPage * this.mehvarTabCurrentPage
      );
      return filtered;
    },
    computedMehvars2() {
      let filtered = [];
      this.obj.forEach((char) => {
        if (this.mehvarsFilter.includes(char.arb)) {
          this.mehvarsFilter = this.mehvarsFilter.replace(char.arb, char.per);
        }
      });

      filtered = this.mehvars.filter((x) =>
        x.name.includes(this.mehvarsFilter)
      );

      return filtered;
    },
    checkMehvarCount() {
      return this.selectedMehvars.length >= 10 ? true : false;
    },
  },
  mounted() {
    if (window.screen.width < 850) {
      this.deviceType = "mobile";
    } else {
      if (document.body.clientWidth < 850) {
        this.deviceType = "mobile";
      } else {
        this.deviceType = "desktop";
      }
    }
    if (window.screen.width > 1515) {
      this.largeScreen = true;
    } else {
      this.largeScreen = false;
    }

    // get all data
    this.getDashboardData();
    this.getData();

    ////go to category tab if catId available
    //if (localStorage.getItem("catId")) {
    //  this.selectCategory();
    //}
  },
};
</script>
<style lang="scss">
.map-modalCard {
  border-radius: 10px !important;
  table {
    border-collapse: separate;
    border-spacing: 0 15px;
  }
  .hidden_header {
    display: none;
  }
  .company_header {
    background-color: white !important;
    border-radius: 15px !important;
    border: none !important;
    margin: 0 10px 10px;
    padding: 0 10px 10px;
    border-spacing: 0 10px 10px;
    // font-weight: bold;
    tr {
      background-color: white !important;
      border: none !important;
    }
    th {
      border-top: none !important;
    }
  }
  .trClass {
    background-color: white;
    border-radius: 15px !important;
    border: none !important;
    margin: 0 10px !important;
    padding: 0 10px 10px;
    // border-spacing: 0 10px 10px;
    td {
      border-top: none !important;
    }
  }

  .trClass td:nth-child(1) {
    border-top-right-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
    padding: 15px;
  }
  .trClass td:nth-child(2) {
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 8px !important;
    padding: 15px;
  }

  table tr:nth-child(2n-1) {
    background-color: #f2f2f5;
    color: #656a81;
  }
  table tr:nth-child(2n) {
    background-color: #fff;
    color: #656a81;
  }

  .trClass > td {
    padding-bottom: 1em;
  }
  .v-text-field__details {
    display: none !important;
  }
  .theme--light.v-pagination .v-pagination__navigation,
  .v-pagination__item {
    background-color: #f2f2f5 !important;
  }
  .v-pagination__item--active {
    background-color: #068d9d !important;
    outline: none !important;
  }
  .item-img {
    width: 85px;
    height: 85px;
    margin: 10px auto;
    border-radius: 50%;
  }
}
#tooltip {
  background-color: rgba(0, 0, 0, 0.65) !important;
  border-radius: 5px !important;
  padding: 7px 10px !important;
  border: none !important;
  color: #fff !important;
  min-width: 150px;
  .name {
    font-size: 13px;
  }
  .requestCount {
    margin-top: 8px;
    border-top: 1px solid #8d8d8d;
    border-bottom: 1px solid #8d8d8d;
    padding: 2px 0;
  }
}
.map-info-panel {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  flex-wrap: wrap;
  justify-content: center;
}

.info-card {
  background: #078d9d;
  border-radius: 12px;
  padding: 15px 25px;
  min-width: 150px;
  text-align: center;
  color: white;
  transition: 0.3s;
}

.info-card:hover {
  transform: translateY(-4px);
}

.info-value {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 6px;
}

.info-title {
  font-size: 14px;
  opacity: 0.9;
}
</style>
